(function() {
  'use strict';

  angular
    .module('achatdemo', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource',
      'ui.router', 'ui.bootstrap', 'chart.js', 'auth0.auth0', 'achat', 'infinicast']);

})();

'use strict';

angular
    .module('achatdemo')
    .factory('banModal', banModalService);


function banModalService($uibModal, discipline) {

    var banModalService = {};

    banModalService.open = function (lan, globalId,userId,name, afterFunc) {
        console.log("opening Ban Modal", lan, globalId,userId,name);
        var ModalInstanceCtrl = function ($scope, $uibModalInstance) {

            $scope.ctrl = {};
            $scope.ctrl.globalId = globalId;
            $scope.ctrl.userId = userId;
            $scope.ctrl.name = name;
            $scope.ctrl.ban = function (timeInMinutes, reason) {
                if (reason) {
                    discipline.banUser(lan, globalId,userId,name, timeInMinutes, reason);
                    $uibModalInstance.close();
                    if (afterFunc) {
                        afterFunc(true);
                    }
                } else {
                    alert("please enter a reason!");
                    
                }
            };
            $scope.close = function () {
                $uibModalInstance.close();
                if (afterFunc) {
                    afterFunc(false);
                }
            };
        };
        $uibModal.open({
            templateUrl: 'app/discipline/banModal/banModal.html',
            backdrop: 'static', // disable click to cancel
            controller: ModalInstanceCtrl
        });
    };
    return banModalService;
}
'use strict';

angular
    .module('achatdemo')
    .factory('yesNoModal', yesNoModalService);


function yesNoModalService($uibModal, discipline) {

    var yesNoModal = {};

    yesNoModal.open = function (title,question, afterFunc) {
        console.log("opening Yes no Modal", title);
        var ModalInstanceCtrl = function ($scope, $uibModalInstance) {

            $scope.ctrl = {};
            $scope.ctrl.title = title;
            $scope.ctrl.question = question;

            $scope.ctrl.yes = function () {
                $uibModalInstance.close();
                if (afterFunc) {
                    afterFunc(true);
                }
            };
            $scope.ctrl.close = function () {
                $uibModalInstance.close();
                if (afterFunc) {
                    afterFunc(false);
                }
            };
        };
        $uibModal.open({
            templateUrl: 'app/discipline/YesNoModal/yesNoModal.html',
            backdrop: 'static', // disable click to cancel
            controller: ModalInstanceCtrl
        });
    };
    return yesNoModal;
}
'use strict';

angular.module('achatdemo')
    .factory('wordFilterEngine', wordFilterEngine);


function wordFilterEngine(infinicast) {
    var wordFilterEngine = {};


    console.log("loading word Filter");
    infinicast.path("/wordFilter/").children.toListAsync().then(function (queryResult) {

        queryResult.list.forEach(function (ele) {
            wordFilterEngine.loadFromArray(ele.path.id, ele.data.words);
        });
    }, function (error) {
        console.error("could not load word filter", error);
    });
    wordFilterEngine.loadFromArray = function (lan, array) {
        wordFilterEngine[lan] = new WordFilterTree();

        array.forEach(function (word) {
            wordFilterEngine[lan].addWord(word);
        });
        console.log("loaded lan " + lan, wordFilterEngine[lan]);
    };


    function WordFilterTree() {
        this.startingChars = {};
        this.finishingChars = {};
        this.addWord = function (item) {
            item = item.toLowerCase();
            if (item.length > 0) {
                var startingChar = item.charAt(0);

                if (!this.startingChars[startingChar]) {
                    this.startingChars[startingChar] = new WordFilterTree();
                }
                if (item.length == 1) {
                    this.finishingChars[startingChar] = true;
                } else {
                    (this.startingChars[startingChar]).addWord(item.substr(1, item.length));
                }
            }
        };
        this.filterAllWords = function (str) {
            var curPos = 0;
            var result = "";
            var lowerStr = str.toLowerCase();
            while (curPos < str.length) {
                var filtered = this.checkFilter(lowerStr, curPos);
                if (filtered > 0) {
                    result += "<< ";
                    for (var i = 0; i < filtered; i++) {
                        //result += "*";
                        result += str.charAt(curPos + i);
                    }
                    result += " >>";
                    curPos += filtered;
                } else {
                    result += str.charAt(curPos);
                    curPos++;
                }
            }
            return result;
        };

        this.checkFilter = function (str, startingIdx) {
            var charAt = str.charAt(startingIdx);
            if (this.finishingChars[charAt]) {
                return 1;
            }
            if (this.startingChars[charAt]) {
                var filterChecked = this.startingChars[charAt].checkFilter(str, startingIdx + 1);
                if (filterChecked > 0) {
                    return filterChecked + 1;
                }
            }
            return 0;
        };
    }


    wordFilterEngine.filterMsg = function (user, msg) {
        if (user && user.lan && wordFilterEngine[user.lan]) {
            return wordFilterEngine[user.lan].filterAllWords(msg);
        } else {
            return msg;
        }
    };

    return wordFilterEngine;
}

'use strict';
/*global Infinicast*/

angular.module('achatdemo')

    .controller('WordFilterController', function ($scope, infinicast, aChatGlobal) {

        var vm = this;
        vm.languageListOptions = aChatGlobal.languageListOptions;

        function convertTextToWords(wordsText) {
            var lines = wordsText.split("\n");
            console.log("changedLines", lines);
            var result = [];
            lines.forEach(function (line) {
                if(result.length<500){
                    if (line.trim().length > 0) {
                        result.push(line.trim());
                    }
                }
            });
            return result;
        }

        function convertWordsToText(words) {
            var txt = "";
            words.forEach(function (ele) {
                txt += ele + "\n";
            });
            return txt;
        }

        $scope.$watch("wordFilterCtrl.selectedLanguage", function (language) {

            vm.changed = false;
            vm.words = null;
            vm.storedWords = null;
            if (language) {
                vm.loading = true;

                infinicast.path("/wordFilter/" + language + "/").getDataAsync().then(function (data) {
                    var txt = "";
                    if (data.data && data.data.words) {
                        txt = convertWordsToText(data.data.words);
                    }
                    vm.words = txt;
                    vm.storedWords = txt;
                    vm.loading = false;
                }, function (error) {
                    console.error("could not load word filter", error);

                });
            }
        });
        vm.save = function () {

            var words = convertTextToWords(vm.words);
            console.log("words", words);
            vm.loading = true;
            infinicast.path("/wordFilter/" + vm.selectedLanguage + "/").setDataAsync({words: words}).then(function (data) {
                vm.storedWords = vm.words;
                vm.loading = false;
                sweetAlert("Success", "Word filter has been saved", "success");
            }, function (error) {
                vm.loading = false;
                sweetAlert("Error", "Could not save word filter", "error");
                console.error("could not save", error);

            });
        };
    });

(function () {
    'use strict';

    angular
        .module('achatdemo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('wordFilter', {
                abstract: true,
                url: "/wordFilter",
                templateUrl: "app/layout/content.html",
                resolve: {
                    security: function (achat) {
                        return achat.isActivatedUser();
                    }
                }
            })
            .state('wordFilter.list', {
                url: "/",
                templateUrl: "app/wordFilter/wordFilter.html",
                data: {pageTitle: 'Word Filters'}
            })
    }

})();

'use strict';
/*global Infinicast*/

angular.module('achatdemo')
    .directive('showErrors', function () {
        return {
            restrict: 'A',
            require: '^form',
            link: function (scope, el, attrs, formCtrl) {

                // find the text box element, which has the 'name' attribute
                var inputEl = el[0].querySelector("[name]");
                // convert the native text box element to an angular element
                var inputNgEl = angular.element(inputEl);
                // get the name on the text box
                var inputName = inputNgEl.attr('name');

                // only apply the has-error class after the user leaves the text box
                var blurred = false;
                inputNgEl.bind('blur', function () {
                    blurred = true;
                    el.toggleClass('has-error', formCtrl[inputName].$invalid);
                });

                scope.$watch(function () {
                    return formCtrl[inputName].$invalid
                }, function (invalid) {
                    // we only want to toggle the has-error class after the blur
                    // event or if the control becomes valid
                    if (!blurred && invalid) {
                        return
                    }
                    el.toggleClass('has-error', invalid);
                });

                scope.$on('show-errors-check-validity', function () {
                    el.toggleClass('has-error', formCtrl[inputName].$invalid);
                });
            }
        }
    })
    .controller('UserListController', function ($scope, infinicast, achat, achatUserData, roleDisplayFilter, aChatGlobal, $uibModal, $log) {

        var vm = this;
        vm.languageListOptions = aChatGlobal.languageListOptions;


        vm.canSeeAuditLogs = achat.user.role == 'dev' || achat.user.role == 'customerService' || achat.user.role == 'customerServiceLead';


        vm.arrayContains = function (array, ele) {
            return array != null && array.indexOf(ele) != -1;
        };

        vm.deleteInvitedUser = function () {

            infinicast.path('/acp/deleteInvite').sendRequest({
                token: vm.selectedInviteUser.token
            }, function (error/*, result*/) {
                if (!error) {
                    sweetAlert("Deleted", "Deleted", "success");
                    updateInvites();
                } else {
                    $log.error("error", error);
                    sweetAlert("Error", "Error", "error");
                }
            });
        };

        vm.deleteSelectedUser = function () {
            achatUserData.deleteOtherUser(vm.selectedUser).then(function () {
                sweetAlert("Deleted", "Deleted", "success");
            }, function (error) {
                $log.error("error", error);
                sweetAlert("Error", "Error", "error");
            });
        };

        vm.roleOptions = achat.getPossibleUserRoles();

        vm.startEditing = function () {
            /*global jQuery*/
            vm.editData = jQuery.extend(true, {}, vm.selectedUser);
        };

        vm.clearUserSelection = function () {
            if (vm.selectedUser) {
                vm.selectedUser.$editing = false;
            }
            vm.selectedUser = null;
            vm.selectedInviteUser = null;
        };
        vm.selectInvite = function (invite) {
            vm.clearUserSelection();
            vm.selectedInviteUser = invite;
            //  /acp/invites/dfgdfsg/
            invite.token = invite.path.pathAddressElement(2);

            invite.inviteHost = window.location.origin;

            invite.inviteUrl = invite.inviteHost + '/invites/' + invite.token;

            $log.log('inviteUser', invite);
        };
        vm.selectUser = function (user) {
            vm.clearUserSelection();

            vm.selectedUser = user;

            console.log("user", user);
            if (vm.canSeeAuditLogs) {
                vm.auditResult = [];
                infinicast.path("/audit/" + user.playerId + "/").children
                    .filterInData(Infinicast.Filter.field('time').gt(new Date().getTime() - 60 * 1000 * 60 * 3))
                    .toList(function (error, list) {
                        if (!error) {
                            $log.log('received audit', list);

                            $scope.$apply(function () {
                                vm.auditResults = list;
                            });
                        } else {
                            $log.error('erorr in audit info', error);
                        }
                    });
            }
        };
        vm.submitChanges = function () {
            var submissionTarget = vm.selectedUser;
            if (vm.selectedUser.$editing) {
                vm.selectedUser.$editing = false;
                achatUserData.changeOtherUser(vm.selectedUser.path, vm.editData).then(function () {
                    submissionTarget.role = vm.editData.role;
                    submissionTarget.info = vm.editData.info;
                }, function (error) {
                    $log.error("error", error);
                    sweetAlert("Error", "Error", "error");
                });

            }
            if (vm.selectedUser.$editingMySelf) {
                vm.selectedUser.$editingMySelf = false;
                achatUserData.changeOwnAccountInfo(vm.editData.info).then(function () {
                    submissionTarget.info = vm.editData.info;
                }, function () {
                    sweetAlert("Error", "Error", "error");
                });
            }

        };

        function unregisterFromEvents() {

        }

        function init() {

        }

        function getRoleOrderNumber(role) {
            switch (role) {
                case "dev":
                    return 1;
                case "customerServiceLead":
                    return 2;
                case "customerService":
                    return 3;
                case "admin":
                    return 4;
                case "mod":
                    return 5;
            }
            return 9;
        }

        var updateInvites = function () {
            infinicast.path("/acp/invites/").children
                .toList(function (error, list) {
                    if (!error) {
                        $log.log('received invites', list);

                        $scope.$apply(function () {
                            vm.invitedUsers = list;
                        });
                    } else {
                        $log.error('error in invites', error);
                    }
                });
        };
        updateInvites();

        achatUserData.getUserList().then(function (resultList) {
            $log.log('received list', resultList);
            vm.list = [];
            resultList.forEach(function (item) {
                if (item.data) {
                    if (!item.data.info) {
                        item.data.info = {};
                    }
                    if (item.data && item.data.info) {
                        var element = {
                            playerId: item.path.id,
                            role: item.data.role,
                            info: item.data.info,
                            fullText: item.data.info.firstname + ' ' + item.data.info.lastname + ' ' + item.data.info.email + ' ' + roleDisplayFilter(item.data.role),
                            path: item.path
                        };

                        if (item.data.online && item.data.online.length > 0) {
                            element.online = true;
                            element.fullText += " online";
                        }
                        if (achat.user.playerId == item.path.id) {
                            element.isThisUser = true;
                        }
                        element.orderText = getRoleOrderNumber(item.data.role) + ' ' + element.fullText;

                        vm.list.push(element);

                    }
                }


            });
            $log.log('list', vm.list);
        });

        $scope.$watchCollection("[userCtrl.filter, userCtrl.list]", function () {
            vm.filteredList = [];


            var splittedFilter = null;
            if (vm.filter) {
                splittedFilter = vm.filter.toLowerCase().split(' ');
            }
            if (vm.list) {
                vm.list.forEach(function (element) {
                    var allowed = true;
                    if (splittedFilter) {
                        splittedFilter.forEach(function (search) {
                            if (element.fullText.toLowerCase().indexOf(search) == -1) {
                                allowed = false;
                            }
                        });
                    }
                    if (allowed) {
                        vm.filteredList.push(element);
                    }
                });
            }
        });


        /*eslint-disable*/
        vm.addNewUser = function () {
            var ModalInstanceCtrl = function ($scope, $uibModalInstance) {

                $scope.editData = {};

                $scope.roleOptions = achat.getPossibleUserRoles();
                $scope.languageListOptions = aChatGlobal.languageListOptions;
                $scope.arrayContains = vm.arrayContains;
                $scope.toggle = vm.arrayContains;
                $scope.finished = false;
                $scope.submitNewUser = function () {
                    $log.log('submitNewUser', $scope.editData);
                    $scope.$broadcast('show-errors-check-validity');

                    if ($scope.inviteForm.$valid) {
                        /*          var token = "meinZufallstoken";
                         infinicast.path("/acp/invites/" + token + "/").setData($scope.editData, function(error) {
                         if (!error) {

                         $log.log('success');
                         } else {
                         $log.error('invite failed', error);
                         }
                         });*/
                        infinicast.path("/acp/addInvite").sendRequest($scope.editData, function (error, answer) {
                            if (!error) {

                                $scope.finished = true;
                                $scope.inviteUrl = answer.inviteUrl.replaceAll("http://localhost:3000", window.location.origin);

                                answer.inviteUrl = $scope.inviteUrl;
//                                sweetAlert("Invite Added", answer.inviteUrl, "success");
                                //                              $uibModalInstance.close();
                                updateInvites();
                                $log.log('addInvite returned', answer);
                            } else {
                                sweetAlert("Error", "Error", "error");
                                $log.error('error in addInvite', error);
                            }
                        });
                    } else {
                        sweetAlert("Please fill all required fields", "Please fill all required fields", "error");
                    }
                };
                $scope.close = function () {
                    $uibModalInstance.close();
                };
            };
            $uibModal.open({
                templateUrl: 'app/user/addNew.html',
                backdrop: 'static', // disable click to cancel
                controller: ModalInstanceCtrl
            });

        };
        /*eslint-enable*/

        $scope.$on("$destroy", unregisterFromEvents);

        init();

    });

(function() {
  'use strict';

  angular
    .module('achatdemo')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('user', {
        abstract: true,
        url: "/user",
        templateUrl: "app/layout/content.html",
        resolve: {
          security: function(achat) {
            return achat.isActivatedUser();
          }
        }
      })
      .state('user.list', {
        url: "/",
        templateUrl: "app/user/userList.html",
        data: {pageTitle: 'User Overview'}
      })
      .state('user.details', {
        url: "/:userId",
        templateUrl: "app/user/userDetails.html",
        data: {pageTitle: 'User Details'}
      });
  }

})();

'use strict';

angular.module('achatdemo')
    .controller('RoomsController', function ($scope, achat, infinicast, achatGameRooms, $stateParams, $log, $timeout, banModal, $rootScope, aChatGlobal, chatRoomsService, ApplicationSettings) {

        var vm = this;


        vm.roomService = chatRoomsService;
        vm.openRooms = chatRoomsService.openRooms;
        //vm.totalCount = null;
        vm.lastUpdate = null;


        vm.instanceList = achat.serverList;

        chatRoomsService.autoScroll = true;

        vm.instanceIdChanged = function () {
            aChatGlobal.setInstanceId(vm.instanceId);
        };

        vm.instanceId = aChatGlobal.getInstanceId();

		switch (ApplicationSettings.game) {
			case 'Darkorbit':

				vm.globalRooms = [];
				vm.globalLocalizedRooms = ['Newbie'];

				vm.staticRooms = [{
					name: 'Global',
                    textTemplate:'INSTANCEID - Global - LANGUAGE',
                    roomTemplate:'INSTANCEID_Global_LANGUAGE'
				}];

				var factions = ['MMO', 'EIC', 'VRU'];
				factions.forEach(function (fac) {
					var ob = {
						name: fac,
                        textTemplate:'INSTANCEID - ' + fac + ' - LANGUAGE',
                        roomTemplate:'INSTANCEID_' + fac + '_LANGUAGE'
					};
					vm.staticRooms.push(ob);
				});

				vm.roomTypes = [{
					name: 'Groups',
					filter: '/room/dyn/INSTANCEID_Group_.*',
					startIdx: 7
				}, {
					name: 'Clan',
					filter: '/room/sys/clan_.*_.*SEARCH.*',
					startIdx: 5
				}, {
					name: 'Refraction Zone',
					filter: '/room/dyn/Rzone_.*',
					startIdx: 6
				}, {
					name: 'UBA (Arena PvP)',
					filter: '/room/dyn/Uba_.*',
					startIdx: 4
				}];

				break;

			case 'Seafight':

				vm.globalRooms = [];
				vm.globalLocalizedRooms = [];

				vm.staticRooms = [{
					name: 'GLOBAL',
                    textTemplate:'INSTANCEID - GLOBAL',
                    roomTemplate:'INSTANCEID_GLOBAL'
				}, {
				    name:"INSTANCE",
                    textTemplate: 'INSTANCEID - INSTANCE - LANGUAGE',
                    roomTemplate: 'INSTANCEID_INSTANCE_LANGUAGE'
				}, {
				    name:"GUILD_SEARCH",
                    textTemplate: 'INSTANCEID - GUILD SEARCH - LANGUAGE',
                    roomTemplate: 'INSTANCEID_GUILD_SEARCH_LANGUAGE'
				}];

				vm.roomTypes = [{
					name: 'Guild',
					filter: '/room/sys/INSTANCEID_GUILD_.*',
					startIdx: 7
				}, {
					name: 'Groups',
					filter: '/room/dyn/INSTANCEID_GROUP_.*',
					startIdx: 7
				}];

				break;

			default:
				console.log('Unknown game ' + ApplicationSettings.game);
				break;
		}

        /*
         Global : Global_lang (ex: Global_en)
         Faction: FactionName_lang (ex: EIC_en)
         Clan: clan_clanId (ex: clan_23423)
         Refraction Zone (Cross server): Rzone_UniqueID (ex: Rzone_234wef)
         UBA (Arena PvP): Uba_UniqueID (ex: Uba_342ffs234)
         */


        /*        function updateChatterList() {
                    var roomPath = getRoomPath(roomName);
                    roomPath.listeners.toList(function (errorInfo, resultList) { // , pathContext
                        if (!errorInfo) {
                            console.log('recieved room list ', resultList);
                            returnPromise.resolve(resultList.items
                                // Throw out empty entries (Services are returned that have no nicks)
                                    .filter(function (entry) {
                                        return !!entry.data["nickName"];
                                    })
                                    // Wrap the result in our own object
                                    .map(function (entry) {
                                        return {
                                            endpoint: entry.endpoint,
                                            nickname: entry.data["nickName"]
                                        };
                                    })
                            );
                        } else {
                            $log.warn("Could not fetch chatter list: " + errorInfo.message);
                            returnPromise.reject(errorInfo);
                        }
                    });
                }*/

        function updateRoomList() {
            var regex = null;


            if (vm.roomType) {
                var roomType = vm.roomType;
                var roomTypeFilter = roomType.filter;

                roomTypeFilter = roomTypeFilter.replaceAll('INSTANCEID', vm.instanceId);
                var filter = vm.filter;
                if(!vm.filter){
                    filter="";
                }
                roomTypeFilter = roomTypeFilter.replaceAll('SEARCH', filter);

                achatGameRooms.listRooms(roomTypeFilter).then(function (data) {

                    vm.list = data.list;
                    vm.list.forEach(function (room) {
                        room.displayName = room.name.substr(roomType.startIdx);
                    });
                    //vm.totalCount = data.totalCount;
                    vm.lastUpdate = new Date();
                }, function (reason) {
                    // Show error
                    $log.error('Could not update room list: ' + reason);
                });
            } else {
                console.log("roomtype not set", vm.roomType);
            }
        }

        vm.refresh = updateRoomList;


        $scope.$watchCollection("[rooms.filter, rooms.list]", function () {
            vm.filteredList = [];


            var splittedFilter = null;
            if (vm.filter) {
                splittedFilter = vm.filter.toLowerCase().split(' ');
            }
            if (vm.list) {
                vm.list.forEach(function (element) {
                    var allowed = true;
                    if (splittedFilter) {
                        splittedFilter.forEach(function (search) {
                            if (element.fullText.toLowerCase().indexOf(search) == -1) {
                                allowed = false;
                            }
                        });
                    }
                    if (allowed) {
                        vm.filteredList.push(element);
                    }
                });
            }
        });


        vm.chat = {};

        vm.chat.openUserByMessage = function (message) {
            console.log("openUserByMessage", message);
            if (!message.role) {
                banModal.open(message.lan, message.globalId,message.userId,message.nickname);
            } else {
                console.error("cannot ban admins");
            }
        };
        vm.chat.send = function (room, msg) {
            $log.log('vm.chat.send', msg);

            if (msg) {
                if (room) {
                    room.path.sendMessage({
                        msg: msg
                    });
                }
            }
            vm.chat.inputLine = '';
        };
        /*$scope.$watch("rooms.selectedRoom", function (selectedRoom, oldValue) {
         $log.log('selected room changed ', selectedRoom, oldValue);

         vm.lastMessage = null;
         vm.roomMessages = [];
         if (oldValue) {
         oldValue.path.onMessage(null); // remove handler
         }
         });*/


        $timeout(function () {
            if (vm.roomService.selectedRoom) {
                vm.openRoomObject(vm.roomService.selectedRoom);
            }
        }, 1);

        vm.changeTab = function (room) {
            vm.openRoomObject(room);
        };
        vm.banUser = function (user) {
            console.log("Banuser called", user);
            banModal.open(user.lan, user.globalId, user.userId, user.nickname);
        };

        vm.closeRoom = function (room) {

            chatRoomsService.closeRoom(room);
        };

        vm.getRoomText=function(instanceId,room,selectedLanguageCode) {
            return room.textTemplate
                .replaceAll("INSTANCEID", instanceId)
                .replaceAll("LANGUAGE", selectedLanguageCode);
        }

        vm.getRoomPath=function(instanceId,room,selectedLanguageCode) {
            return room.roomTemplate
                .replaceAll("INSTANCEID", instanceId)
                .replaceAll("LANGUAGE", selectedLanguageCode);
        }

		/**
		 * Open view of a chat room
		 *
		 * @param {string} instanceId - ID of instance this room belongs to. null for global room.
		 * @param {string} roomName - actual name of the room
		 * @param {bool} addLanguageCode - true to open a localized room in currently selected locale
		 */
		vm.openRoom = function(roomName, instanceId, addLanguageCode) {
			var roomPath = '/room/sys/';
			var fullRoomName = '';

			if (instanceId) {
				roomPath += instanceId + '_';
				fullRoomName += instanceId + ' ';
			}
			roomPath += roomName;
			fullRoomName += roomName;
			if (addLanguageCode) {
				roomPath += '_' + $rootScope.selectedLanguageCode;
				fullRoomName += ' ' + $rootScope.selectedLanguageCode;
			}
			roomPath += '/';
			chatRoomsService.openRoom(roomPath, fullRoomName);
		};
        /**
         * Open view of a chat room New with object
         *
         * @param {string} instanceId - ID of instance this room belongs to. null for global room.
         * @param {room} room - room object
         * @param {bool} addLanguageCode - true to open a localized room in currently selected locale
         */
        vm.openRoomNew = function(room, instanceId, addLanguageCode) {
            var roomPath = '/room/sys/';
            var fullRoomName = '';

            roomPath += vm.getRoomPath(instanceId,room,$rootScope.selectedLanguageCode);
            fullRoomName = vm.getRoomText(instanceId,room,$rootScope.selectedLanguageCode);

            roomPath += '/';
            chatRoomsService.openRoom(roomPath, fullRoomName);
        };
        vm.openRoomObject = function (room) {
            console.log("opening room ", room);
            chatRoomsService.openRoom(room.path.toString(), room.name);
        };

        function destroy() {

            /*            vm.openRooms.forEach(function (room) {
                            room.path.onMessage(null); // remove handler
                        });*/
            // If the room list is fetched live, we have to stop it here
        }

        $scope.$on("$destroy", destroy);


    });

'use strict';

angular
    .module('achatdemo')
    .factory('chatRoomsService', chatRoomsService);


function chatRoomsService(infinicast, $log, $timeout, $rootScope, wordFilterEngine) {

    var chatRoomsService = {};

    var openRoomHash = {};

    chatRoomsService.openRooms = [];
    chatRoomsService.selectedRoom = null;
    var userColors = {};

    var randomColor = function () {
        var r = Math.round(Math.random() * 255);
        var g = Math.round(Math.random() * 255);
        var b = Math.round(Math.random() * 255);

        if (r > 180 && g > 180 && b > 180) {
            return randomColor();
        }
        var rtxt = r.toString(16);
        while (rtxt.length < 2) {
            rtxt = "0" + rtxt;
        }
        var gtxt = g.toString(16);
        while (gtxt.length < 2) {
            gtxt = "0" + gtxt;
        }
        var btxt = b.toString(16);
        while (btxt.length < 2) {
            btxt = "0" + btxt;
        }
        return "#" + rtxt + gtxt + btxt;
    };

    var doAutoScroll = function () {
//        console.info('autoscrolling2');
        if (chatRoomsService.autoScroll) {
            //          console.info('autoscrolling3');
            $timeout(function () {
                //            console.info('autoscrolling4');

                /*eslint-disable*/


                var chatDiv = $(".chat-discussion.selected")[0];
                /*eslint-enable*/
                if (chatDiv) {
                    //       console.info('autoscrolling');
                    chatDiv.scrollTop = chatDiv.scrollHeight;
                } else {
                    //     console.error('chat discussion not existing');
                }
            }, 0);
        }
    };



    chatRoomsService.openRoom = function (roomPath, name) {
        if (!openRoomHash[roomPath]) {
            var roomOb = openRoomHash[roomPath] = {
                roomMessages: [],
                filteredChattingUsers: [],
                filteredChattingMods: [],
                chattingUsers: [],
                chattingUserHash: {},
                filter: '',
                name: name,
                roomPath: roomPath,
                path: infinicast.path(roomPath)
            };

            roomOb.isUserVisibleInFilter = function (user) {
                return !roomOb.filter || user.userId && user.userId.indexOf(roomOb.filter) !== -1 || user.globalId && user.globalId.indexOf(roomOb.filter) !== -1;
            };
            roomOb.addUserToFilteredList=function(user){
                if (roomOb.isUserVisibleInFilter(user)) {
                    if (user.globalId) {
                        roomOb.filteredChattingUsers.push(user);
                    } else {
                        roomOb.filteredChattingMods.push(user);
                    }
                }
            };
            roomOb.filterChanged = function () {
                var filter = roomOb.filter;
                roomOb.filteredChattingUsers = [];
                roomOb.filteredChattingMods = [];
                roomOb.chattingUsers.forEach(function (user) {
                    roomOb.addUserToFilteredList(user);
                });
            };
            chatRoomsService.openRooms.push(roomOb);
            console.log("opening room ", roomPath);
            infinicast.path(roomPath).onMessage(function (msg, context) {

                $log.log('msg', msg, context);
                var senderName = '';
                var senderRole = '';
                var userId = '';
                var globalId = '';
                var lan = '';
                if (context.endpointData) {
                    senderName = context.endpointData.userId;
                    senderRole = context.endpointData.role;
                    userId = context.endpointData.id;
                    globalId = context.endpointData.globalId;
                    lan = context.endpointData.lan;
                    if(!globalId){ // moderator
                        userId = context.endpointData.userId;
                    }
                }
                if (!userColors[senderName]) {

                    userColors[senderName] = randomColor();
                }

                roomOb.lastMessage = new Date();
                roomOb.roomMessages.push({
                    msg: wordFilterEngine.filterMsg(context.endpointData, msg.msg),
                    nickname: senderName,
                    userColor: userColors[senderName],
                    userId: userId,
                    globalId: globalId,
                    role: senderRole,
                    lan: lan,
                    timestamp: new Date()
                });
                if (!roomOb.chattingUserHash[userId]) {
                    var userOb = {
                        nickname:senderName,
                        userId: userId,
                        globalId: globalId,
                        role: senderRole,
                        color: userColors[senderName],
                        lan: lan
                    };
                    roomOb.chattingUserHash[userId] = userOb;
                    roomOb.chattingUsers.push(userOb);

                    roomOb.addUserToFilteredList(userOb);
                }

                console.log("here,", roomOb);
                if (roomOb === chatRoomsService.selectedRoom) {
                    roomOb.openMessages = '';
                    roomOb.openMessageCount = 0;

                    doAutoScroll();
                } else {
                    roomOb.openMessageCount++;
                    roomOb.openMessages = "[" + roomOb.openMessageCount + "]";
                }
                $rootScope.$apply(function () {
                });
            });
        }
        openRoomHash[roomPath].openMessages = '';
        openRoomHash[roomPath].openMessageCount = 0;
        chatRoomsService.activeTab = chatRoomsService.openRooms.indexOf(openRoomHash[roomPath]);

        if (chatRoomsService.selectedRoom) {
            chatRoomsService.selectedRoom.active = false;
        }
        openRoomHash[roomPath].active = true;
        chatRoomsService.selectedRoom = openRoomHash[roomPath];
        // ensure that all scopes receive the changed activeTab
        if (!$rootScope.$$phase) {
            $rootScope.$apply(function () {

            });
        }
        //  console.info('autoscroll0');
        $timeout(function () {
            //    console.info('autoscroll1');
            $timeout(function () {
                //      console.info('autoscroll2');
                doAutoScroll();
            }, 100);
        }, 100)
    };
    chatRoomsService.closeRoom = function (room) {
        openRoomHash[room.roomPath] = null;
        chatRoomsService.openRooms.splice(chatRoomsService.openRooms.indexOf(room), 1);
        room.path.onMessage(null); // remove handler

        room.active = false;
        if (chatRoomsService.openRooms.length > 0) {
            var selectedAfter = chatRoomsService.openRooms[0];
            selectedAfter.active = true;
            chatRoomsService.openRoom(selectedAfter.path.toString(), selectedAfter.name);
        }

    };
    return chatRoomsService;
}
(function() {
  'use strict';

  angular
    .module('achatdemo')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('rooms', {
        abstract: true,
        url: "/rooms",
        templateUrl: "app/layout/content.html",
        resolve: {
          security: function(achat) {
            return achat.isActivatedUser();
          }
        }
      })
      .state('rooms.index', {
        url: "/:game",
        templateUrl: "app/rooms/list.html",
        data: {pageTitle: 'Example view'}
      })/*
     .state('rooms.chat', {
     url: "/:roomName",
     templateUrl: "app/rooms/chat.html",
     data: {pageTitle: 'Example view'}
     })*/;
  }

})();

/**
 * INSPINIA - Responsive Admin Theme
 * 2.5
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeigh > wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
    }

    if(navbarHeigh < wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeigh > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('achatdemo')
    /**
    * sideNavigation - Directive for run metisMenu on sidebar navigation
    */
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metis to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

            }
        };
    })

    /**
     * minimalizaSidebar - Directive for minimalize sidebar
    */
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    })

    /**
     * fullScroll - Directive for slimScroll with 100%
     */
   .directive('fullScroll', function ($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                $timeout(function(){
                    element.slimscroll({
                        height: '100%',
                        railOpacity: 0.9
                    });

                });
            }
        };
    });

'use strict';
angular.module('achatdemo')
    .controller('MainController', function (authService, achat, aChatGlobal, $rootScope, ApplicationSettings) {

        var vm = this;

        vm.auth = authService;

        vm.user = achat.user;

        vm.selectedLanguage = aChatGlobal.getSelectedLanguage();

		vm.logoName = ApplicationSettings.logoName;

        vm.languageChanged = function () {
            aChatGlobal.setSelectedLanguage(vm.selectedLanguage);
        };
        vm.languageListOptions = aChatGlobal.languageListOptions;

        var titleSize = 240;
        aChatGlobal.stdContentHeight=window.innerHeight-titleSize;
        $rootScope.stdContentHeight = aChatGlobal.stdContentHeight;
        $(window).resize(function () {
            $rootScope.$apply(function () {
                $rootScope.stdContentHeight = window.innerHeight-titleSize;
                aChatGlobal.stdContentHeight = window.innerHeight-titleSize;
            });
        });
    });

'use strict';

angular.module('achatdemo')
    .controller('InviteController', function ($stateParams, infinicast, $log, achat, $state) {
        var vm = this;

        vm.token = $stateParams.token;

        vm.state = "loading";

        if (achat.user && achat.user.isActivated) {
            console.log("user already activated");
            $state.go('user.list');
        } else {
            $log.log('sending token ', vm.token);

            infinicast.path("/acp/acceptInvite").sendRequest({
                token: vm.token
            }, function (error, result) {
                if (error) {
                    vm.state = "error";
                } else {
                    vm.state = "success";

                    location.reload();
                }
                $log.log(error, result);
            });
        }

    });

(function() {
  'use strict';

  angular
    .module('achatdemo')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('invites', {
        abstract: true,
        url: "/invites",
        templateUrl: "app/layout/content.html",
        resolve: {
          security: function(achat) {
            return achat.isLoggedIn();
          }
        }
      })
      .state('invites.entry', {
        url: "/:token",
        templateUrl: "app/invites/invite.html",
        data: {pageTitle: 'Invite accept'}
      });
  }

})();

'use strict';

angular.module('achatdemo')
    .controller('HistoryController', function ($scope, achat, achatGameRooms, $stateParams, infinicast, $timeout, $log, discipline, banModal) {

        var vm = this;

        vm.query = {};
        vm.query.roomType = "sys";
        vm.onDateRangeChanged = function (start, end) {
            vm.query.start = moment(start).toDate();
            vm.query.end = moment(end).toDate();
        };

        vm.selectUserByMessage = function (msg) {
            console.log('selectUserByMessage ', msg);
            if (!msg.data.globalId) {
                sweetAlert("no global id found", "Error", "error");
            } else {
                banModal.open(msg.data.lan, msg.data.globalId,msg.data.userId,msg.data.nickName);
            }
        };

        vm.searchHistory = function () {

            var room = '*/*';
            if (vm.query.room && vm.query.roomType) {
                room = vm.query.roomType + "/" + vm.query.room;
            }

            // search for any language, any server, any room or a given room

            var filterChain = infinicast.path("/history/room/" + room + "/").children;

            filterChain = filterChain.filterInData(Infinicast.Filter.field('date').gt(vm.query.start.getTime()));
            filterChain = filterChain.filterInData(Infinicast.Filter.field('date').lt(vm.query.end.getTime()));

            if (vm.query.userName) {
                filterChain = filterChain.filterInData(Infinicast.Filter.field('nickName').eq(vm.query.userName));
            } else if (vm.query.globalId) {
                filterChain = filterChain.filterInData(Infinicast.Filter.field('globalId').eq(vm.query.globalId));
            }else if (vm.query.userId) {
                filterChain = filterChain.filterInData(Infinicast.Filter.field('userId').eq(vm.query.userId));
            }
            filterChain = filterChain.limit(1000);
            filterChain.toList(function (error, list, totalResults) {
                if (!error) {
                    $log.log('received history', list, totalResults);

                    vm.totalResults = totalResults;

                    var roomHash = {};
                    var roomArray = [];
                    // group into rooms and messages to display it in tabs.
                    list.forEach(function (ele) {
                        var roomType = ele.path.pathAddressElement(2);
                        var roomName = roomType + "/" + ele.path.pathAddressElement(3);
                        console.log("ele", ele, roomName);
                        if (roomName) {
                            if (!roomHash[roomName]) {
                                var newRoom = {
                                    name: roomName,
                                    messages: []
                                };
                                roomHash[roomName] = newRoom;
                                roomArray.push(newRoom);
                            }
                            roomHash[roomName].messages.push(ele);
                        }
                    });

                    $scope.$apply(function () {

                        vm.historyRooms = roomArray;


                        console.log('historyResults', list, vm.historyRooms);
                    });
                } else {
                    $log.error('error in history info', error);
                }
            });
        };


        vm.ban = function () {
            if (!vm.selectedUser.globalId) {
                sweetAlert("no global id found", "Error", "error");
            } else {
                console.log("history delete selected ", vm.selectedUser);
                discipline.banUser(vm.selectedUser.lan, vm.selectedUser.globalId, vm.selectedUser.userId, vm.selectedUser.nickName, 1, vm.banReason);
            }
        };


        // init time frame picker
        $timeout(function () {
            var drp = $('input.daterange').daterangepicker({
                    "timePicker24Hour": true,
                    timePicker: true,
                    locale: {
                        format: 'DD.MM.YYYY HH:mm'
                    }
                },
                function (start, end, label) {
                    $scope.$apply(function () {
                        vm.onDateRangeChanged(start, end);
                    });
                }).data('daterangepicker');

            var start = moment().subtract(1, 'hours');
            var end = moment();
            vm.query.start = moment(start).toDate();
            vm.query.end = moment(end).toDate();

            drp.setStartDate(start);
            drp.setEndDate(end);
        }, 0);
    });

(function () {
    'use strict';

    angular
        .module('achatdemo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('history', {
                abstract: true,
                url: "/history",
                templateUrl: "app/layout/content.html",
                resolve: {
                    security: function (achat) {
                        return achat.isActivatedUser();
                    }
                }
            })
            .state('history.index', {
                url: "/:game",
                templateUrl: "app/history/history.html",
                data: {pageTitle: 'History'}
            });
    }

})();

'use strict';

angular.module('achatdemo')
    .controller('GsMonitoringController', function ($scope,$http, $interval) {


        var serverUrl = "http://e2e-exporter.darkorbit.infinicast.io:8080/";
        //serverUrl = "http://127.0.0.1:8080/";
        $scope.servers=[];

        $scope.filter={};
        $scope.problematicServers="";
        $scope.order={};
        $scope.order.field = "timeSinceKeepAlive";


        function updateList(){

            $http({
                url: serverUrl+"GSListProdProblems/",
                method: 'GET',
                transformResponse: null
            })
                .then(function(response) {
                    $scope.problematicServers = response.data;
                });

            $http.get(serverUrl+"GSListDev/")
                .then(function(response) {

                    $scope.servers = response.data;

                    $scope.servers.forEach(function(svr){
                        svr.filterTxt = svr.instanceId+" "+svr.instanceName;

                        svr.timeSinceKeepAliveText = Math.round(svr.timeSinceKeepAlive / (1000*60));
                    });
                    /*			console.log("huhu");
                                console.log("hier",response.data);
                                $scope.myWelcome = response.data;*/
                });
 /*           $http.get(serverUrl+"GSListProd/")
                .then(function(response) {


                    $scope.servers = response.data;

                    $scope.servers.forEach(function(svr){
                        svr.filterTxt = svr.instanceId+" "+svr.instanceName;
                        svr.timeSinceKeepAliveText = Math.round(svr.timeSinceKeepAlive / (1000*60));
                    });
                });*/
        }

        updateList();

        $interval(function(){
            updateList();
        },60000);
    });

(function () {
    'use strict';

    angular
        .module('achatdemo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {
        $stateProvider
            .state('gsMonitoring', {
                abstract: true,
                url: "/gsMonitoring",
                templateUrl: "app/layout/content.html",
                resolve: {
                    security: function (achat) {
                        return achat.isActivatedUser();
                    }
                }
            })
            .state('gsMonitoring.index', {
                url: "/:game",
                templateUrl: "app/gsMonitoring/gsMonitoring.html",
                data: {pageTitle: 'GS Monitoring'}
            });
    }

})();

/**
 * chartJsCtrl - Controller for data for ChartJs plugin
 * used in Chart.js view
 */

angular.module('achatdemo')
  .controller('NotActivatedController', function(achat, achatUserData, aChatGlobal) {

      var vm = this;

      vm.userData = achat.user.info;
      if (!vm.userData) {
        vm.userData = {};
      }

      vm.languageListOptions = aChatGlobal.languageListOptions;

      vm.submit = function() {
        achatUserData.changeOwnAccountInfo(vm.userData).then(function() {
          sweetAlert("Updated", "Your account info has been updated", "success");
        }, function() {
          sweetAlert("Error", "Could not update your account info", "error");
        });
      };
    }
  )
;

(function() {
  'use strict';

  angular
    .module('achatdemo')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('error', {
        abstract: true,
        url: "/error",
        templateUrl: "app/layout/error.html"
      })
      .state('error.notLoggedIn', {
        url: "/notLoggedIn",
        templateUrl: "app/error/notLoggedIn.html",
        data: {pageTitle: 'Not Logged In'}
      })
      .state('error.notActivated', {
        url: "/notActivated",
        templateUrl: "app/error/notActivated.html",
        data: {pageTitle: 'Not Activated'}
      });
  }

})();

'use strict';

angular.module('achatdemo')
    .controller('ReportsController', function ($scope, achat, infinicast, $stateParams, $log, discipline, banModal, $rootScope, aChatGlobal,yesNoModal) {

        var vm = this;

        vm.selectedReport = null;
        vm.totalCount = null;
        vm.reports = [];
        vm.lastUpdate = null;


        function updateReportList() {

            vm.list = [];

            console.log("updateReportList", $rootScope.selectedLanguageCode);
            var findElementInList = function (id) {
                var resultIdx = -1;
                vm.list.forEach(function (ele, itemIdx) {
                    if (ele.path.id == id) {
                        resultIdx = itemIdx;
                    }
                });
                return resultIdx;
            };

            var criteria = new Infinicast.SortCriteria();
            criteria.field = "time";
            criteria.isAscending = true;
            infinicast.path("/report/open/" + aChatGlobal.getSelectedLanguage() + "/*/").children.orderByData(criteria).limit(50).toList(function (error, pathAndDataList) {
                if (!error) {

                    vm.list = [];
                    pathAndDataList.forEach(function (pathAndData) {
                        var params = pathAndData.path.extractPathParams("/report/open/$lan/$globalId/");
                        var newEntry = {
                            lan: params["lan"],
//                            name: params["userId"],
                            globalId:params["globalId"],
                            fullText: params["globalId"],
                            data: pathAndData.data,
                            path: pathAndData.path
                        };
                        if(pathAndData.data){

                            console.log("newwntry",newEntry);
                            if(newEntry.data.reportList){
                                console.log("resultList",newEntry.data.resultList);
                                newEntry.data.reportList.forEach(function(entry){
                                    newEntry.name = entry.nickname;
                                    newEntry.userId = entry.userId;
                                    if(entry.msg){
                                        entry.msgs = entry.msg.split('\n');
                                    }
                                    console.log("entry",entry);
                                });
                            }
                            if(newEntry.userId){
                                newEntry.fullText+=" "+newEntry.userId;
                            }
                        }
                        vm.list.push(newEntry);
                    });
                    $scope.$apply(function () {
                        updateFilteredList();
                    });
                } else {
                    sweetAlert("Error", "could not get list", error);
                }
            });

        }


        function updateFilteredList() {
            vm.filteredList = [];
            var splittedFilter = null;
            if (vm.filter) {
                splittedFilter = vm.filter.toLowerCase().split(' ');
            }
            if (vm.list) {
                vm.list.forEach(function (element) {
                    var allowed = true;
                    if (splittedFilter) {
                        splittedFilter.forEach(function (search) {
                            if (element.fullText.toLowerCase().indexOf(search) == -1) {
                                allowed = false;
                            }
                        });
                    }
                    if (allowed) {
                        vm.filteredList.push(element);
                    }
                });
            }
        }

        $scope.$watchCollection("[reports.filter, reports.list]", function () {
            updateFilteredList();

        });

        /*$scope.$watch("reports.selectedReport", function(selectedReport, oldValue) {
         $log.log('selected report changed ', selectedReport, oldValue);
         });*/


        vm.actualMarkResolved = function(report,hideMessage){
            report.path.path("markResolved").sendRequest({resolved: true}, function (error) {
                if (!error) {
                    vm.list.splice(vm.list.indexOf(report), 1);
                    vm.selectedReport = null;
                    $scope.$apply(function () {
                        updateFilteredList();
                    });
                    if (!hideMessage) {
                        sweetAlert("Reports have been marked resolved", "Reports have been marked resolved", "success");
                    }
                } else {
                    $log.error('could mark resolved', error);
                    sweetAlert("could not mark resolved", "Error", "error");
                }
            });

        };
        vm.markResolved = function (hideMessage) {
            if (vm.selectedReport) {
                var report = vm.selectedReport;
                yesNoModal.open('Mark resolved','Do you really want to mark the user resolved?',function(yes){
                    if(yes){
                        vm.actualMarkResolved(report,hideMessage);
                    }
                });

            }
        };
        vm.ban = function () {
            if (vm.selectedReport) {
                var report = vm.selectedReport;

                var params = report.path.extractPathParams("/report/open/$lan/$globalId/");

                var globalId = params["globalId"];
                var lan = params["lan"];

            //    reports.selectedReport.name}}" userid="{{reports.selectedReport.userId}}" globalid="{{reports.selectedReport.globalId

                //banModal.open(user.lan, user.globalId, user.userId, user.nickname);
                banModal.open(lan, globalId,vm.selectedReport.userId,vm.selectedReport.name, function (hasBeenBanned) {
                    if(hasBeenBanned){
                        vm.actualMarkResolved(report,true);
                    }
                });
            }
        };

        $scope.$watch("selectedLanguageCode", function () {
            updateReportList();
        });


        vm.updateList = function () {
            updateReportList();
        };

        function destroy() {
            /*if (vm.selectedReport) {
                vm.selectedReport.path.onDataChange(null); // remove handler
            }*/
            // If the report list is fetched live, we have to stop it here
        }

        $scope.$on("$destroy", destroy);

    });

'use strict';

angular
    .module('achatdemo')
    .controller('DisciplinesController', DisciplinesController);


function DisciplinesController($scope, $stateParams, $log, infinicast,aChatGlobal,$rootScope) {

    var vm = this;

    vm.selectedDiscipline = null;
    vm.lastUpdate = new Date();

    /*
     function updateDisciplineList() {

     vm.list = [];

     var findElementInList = function(id) {
     var resultIdx = -1;
     vm.list.forEach(function(ele, itemIdx) {
     if (ele.path.id == id) {
     resultIdx = itemIdx;
     }
     });
     return resultIdx;
     };
     var onAdd = function(json, context) {
     $log.log('onAdd', json, context);
     var newEntry = {
     name: context.path.id,
     fullText: context.path.id,
     data: json,
     path: context.path
     };
     vm.list.push(newEntry);
     $scope.$apply(function() {
     updateFilteredList();
     });
     };
     var onRemove = function(json, context) {

     var removedIdx = findElementInList(context.path.id);
     $log.log('onRemove', context.path.id, removedIdx, json, context);
     if (removedIdx != -1) {
     vm.list.splice(removedIdx, 1);
     $scope.$apply(function() {
     updateFilteredList();
     });
     }
     };
     var onChange = function(json, context) {
     $log.log('onChange', json, context);
     var idx = findElementInList(context.path.id);
     if (idx != -1) {
     vm.list[idx].path = context.path;
     vm.list[idx].data = json;
     $log.log('update', vm.list[idx]);
     $scope.$apply(function() {
     updateFilteredList();
     });
     }
     };

     infinicast.path("/discipline/").children.live(onAdd, onRemove, onChange);
     }*/

    /*  function updateFilteredList() {
     vm.filteredList = [];

     var splittedFilter = null;
     if (vm.filter) {
     splittedFilter = vm.filter.toLowerCase().split(' ');
     }
     if (vm.list) {
     vm.list.forEach(function(element) {
     var allowed = true;
     if (splittedFilter) {
     splittedFilter.forEach(function(search) {
     if (element.fullText.toLowerCase().indexOf(search) == -1) {
     allowed = false;
     }
     });
     }
     if (allowed) {
     vm.filteredList.push(element);
     }
     });
     }
     }
     */
    /*  $scope.$watchCollection("[reports.filter, reports.list]", function() {
     //updateFilteredList();
     });
     */
    vm.query = {};

    vm.searchUserDiscipline=function(){

        var filterChain = infinicast.path("/discipline/").children;

        if (vm.query.userName) {
            filterChain = filterChain.filterInData(Infinicast.Filter.field('name').eq(vm.query.userName));
        } else if (vm.query.globalId) {
            return vm.searchGlobalId(vm.query.globalId);
        }else if (vm.query.userId) {
            filterChain = filterChain.filterInData(Infinicast.Filter.field('userId').eq(vm.query.userId));
        }

        var criteria = new Infinicast.SortCriteria();
        criteria.field = "userId";
        criteria.isAscending = false;

        filterChain = filterChain.orderByData(criteria);
        filterChain = filterChain.limit(1);
        filterChain.toList(function (error, list, totalResults) {
            if (!error) {
                $log.log('received disciplines', list, totalResults);

                var first = true;
                // group into rooms and messages to display it in tabs.
                $scope.$apply(function () {
                    vm.selectedDiscipline = null;
                    list.forEach(function (ele) {
                        if(first){
                            first = false;
                            if (ele.data && ele.data.until) {
                                vm.selectedDiscipline = {
                                    name:  ele.data.name,
                                    userId:  ele.data.userId,
                                    globalId: ele.data.globalId,
                                    data:  ele.data,
                                    path: infinicast.path("/discipline/" +  ele.data.globalId + "/")
                                };
                            } else {
                                vm.selectedDiscipline = null;
//                                sweetAlert("user has no discipline info", "Error", "error");
                            }
                        }
                    });
                });
            } else {
                console.log("error",error);
                $log.error('error in discipline error info', error);
            }
        });
    };

    vm.searchGlobalId = function (globalId) {
        infinicast.path("/discipline/" + globalId + "/").getDataAsync().then(function (data) {
            //$scope.$apply(function () {
                if (data && data.data && data.data.until) {
                    vm.selectedDiscipline = {
                        name: data.data.name,
                        userId: data.data.userId,
                        globalId: globalId,
                        data: data.data,
                        path: infinicast.path("/discipline/" + globalId + "/")
                    };
                } else {
                    vm.selectedDiscipline = null;
//                sweetAlert("user has no discipline info", "Error", "error");
                }
            //});
        }, function (error) {
            sweetAlert("could not open discipline", "Error", "error");
        });

    };
    vm.unban = function () {
        if (vm.selectedDiscipline) {
            var discipline = vm.selectedDiscipline;
            vm.selectedDiscipline = null;
            //updateFilteredList();
            discipline.path.path("delete").sendRequest({}, function (error) {
                if (!error) {
                    sweetAlert("UnBanning", "unbanned!", "success");
                } else {
                    $log.error('could unban', error);
                    sweetAlert("could not delete", "Error", "error");
                }
            });
        }
    };


    function updateRecentList() {

        vm.list = [];

        console.log("updateRecentList", $rootScope.selectedLanguageCode);

        var findElementInList = function (id) {
            var resultIdx = -1;
            vm.list.forEach(function (ele, itemIdx) {
                if (ele.path.id == id) {
                    resultIdx = itemIdx;
                }
            });
            return resultIdx;
        };

        var criteria = new Infinicast.SortCriteria();
        criteria.field = "time";
        criteria.isAscending = false;
        infinicast.path("/recentDiscipline/" + aChatGlobal.getSelectedLanguage() + "/*/").children.orderByData(criteria).limit(100).toList(function (error, pathAndDataList) {
            if (!error) {

                vm.recentList = [];
                pathAndDataList.forEach(function (pathAndData) {
                    var params = pathAndData.path.extractPathParams("/recentDiscipline/$lan/");
                    var newEntry = {
                        lan: params["lan"],
                        data: pathAndData.data,
                        path: infinicast.path("/discipline/" +  pathAndData.data["globalId"] + "/")
                    };
                    if(pathAndData.data){
                        newEntry.by = pathAndData.data["by"];
                        newEntry.byName = pathAndData.data["byName"];
                        newEntry.time = pathAndData.data.time;
                        newEntry.until = pathAndData.data.until;
                        newEntry.reason  = pathAndData.data.reason;
                        newEntry.type =  pathAndData.data.type;

                        newEntry.userId = pathAndData.data["userId"];
                        newEntry.globalId = pathAndData.data["globalId"];
                        newEntry.name = pathAndData.data["name"];
                        newEntry.resason = pathAndData.data["reason"];
                    }
                    vm.recentList.push(newEntry);
                });
                $scope.$apply(function () {
                });
            } else {
                sweetAlert("Error", "could not get list", error);
            }
        });

    }

    vm.updateRecentList = function () {
        updateRecentList();
    };

    vm.selectRecent = function (recent) {
        vm.selectedDiscipline = recent;
    };

    function init() {
        //updateDisciplineList();
        updateRecentList();
    }

    function destroy() {
        if (vm.selectedReport) {
            vm.selectedReport.path.onDataChange(null); // remove handler
        }
        // If the report list is fetched live, we have to stop it here
    }

    $scope.$on("$destroy", destroy);
    init();
}
'use strict';

angular
    .module('achatdemo')
    .factory('discipline', disciplineService);


function disciplineService(infinicast, $log) {

    var disciplineService = {};

    disciplineService.banUser = function (lan, globalId, userId, name, timeInMinutes, reason) {
        var path = "/report/open/" + lan + "/" + globalId + "/ban";

        if (!reason) {
            reason = "";
        }

        $log.log('banning ', path, timeInMinutes, reason);
        infinicast.path(path).sendRequest({
            timeInMinutes: timeInMinutes,
            userId: userId,
            name: name,
            reason: reason
        }, function (error) {
            if (!error) {
                sweetAlert("Banning user for " + timeInMinutes + " minute", "banned", "success");
            } else {
                $log.error('could ban', error);
                sweetAlert("could not ban", "Error", "error");
            }

        });
    };
    return disciplineService;
}
(function() {
  'use strict';

  angular
    .module('achatdemo')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('discipline', {
        abstract: true,
        url: "/discipline",
        templateUrl: "app/layout/content.html",
        resolve: {
          security: function(achat) {
            return achat.isActivatedUser();
          }
        }
      })
      .state('discipline.reports', {
        url: "/reports/",
        templateUrl: "app/discipline/reports.html",
        controller: 'ReportsController',
        controllerAs: 'reports'
      })
      .state('discipline.disciplines', {
        url: "/disciplines/",
        templateUrl: "app/discipline/disciplines.html",
        controller: 'DisciplinesController',
        controllerAs: 'disciplines'
      })
  }

})();

(function() {
  'use strict';

  angular
    .module('achatdemo')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('callback', {
        abstract: true,
        url: "/callback",
        templateUrl: "app/layout/content.html"
      })
      .state('callback.index', {
          url: '',
        templateUrl: "app/callback/callback.html"
      });
  }

})();

(function () {

    'use strict';

    angular
        .module('achatdemo')
        .service('authService', authService);

    authService.$inject = ['$state', 'angularAuth0', 'achat', 'ApplicationSettings'];

    function authService($state, angularAuth0, achat, ApplicationSettings) {

        var _isAuthenticated;

        function login() {
            angularAuth0.authorize();
        }

        function handleAuthentication() {

            // angularAuth0.parseHash is not usable for authorization_code flow

            var authorizationCode = getParameterByName('code');
            if (authorizationCode) {

                console.log('Received authorization code');

                var redirectUri = ApplicationSettings.redirect_uri;
                achat.connectAndLogin(redirectUri,authorizationCode);

                _isAuthenticated = true;
            } else {
                achat.loginAndConnectDefer.reject('notLoggedIn');
            }

        }

        function logout() {
            _isAuthenticated = false;

            angularAuth0.logout({
                returnTo: window.location.origin
            });

            $state.go('dashboard');
        }

        function isAuthenticated() {
            return _isAuthenticated;
        }

        // http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
        function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        return {
            login: login,
            handleAuthentication: handleAuthentication,
            logout: logout,
            isAuthenticated: isAuthenticated
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('achatdemo')
        .run(runBlock);

    /** @ngInject */
    function runBlock($log, $rootScope, $state, $location, authService) {

        String.prototype.replaceAll = function (search, replacement) {
            var target = this;
            return target.replace(new RegExp(search, 'g'), replacement);
        };

        /*eslint-disable*/
        $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            /*eslint-enable*/

            $log.log('stateChangeError', error, toState);
            if (error === "redirectToDashboard") {
                $state.go("dashboard.main");
            } else {
                if (error === "notActivated") {
                    $state.go("error.notActivated");
                }
                if (error === "notLoggedIn") {
                    localStorage.setItem('return_uri', $state.href(toState, toParams));
                    authService.login();
                }
            }
        });

        // Try if URL contains authorization_code
        authService.handleAuthentication();

        $log.debug('runBlock end');
    }

})();

(function () {
    'use strict';

    angular
        .module('achatdemo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $locationProvider, $urlRouterProvider, angularAuth0Provider, ApplicationSettings) {

        $urlRouterProvider.otherwise('/user/');

        $locationProvider.hashPrefix('');

        /// Comment out the line below to run the app
        // without HTML5 mode (will use hashes in routes)
        $locationProvider.html5Mode(true);

        // Initialization for the angular-auth0 library
        angularAuth0Provider.init({
            clientID: ApplicationSettings.clientId,
            domain: ApplicationSettings.auth0Domain,
            responseType: 'code',
            redirectUri: ApplicationSettings.redirect_uri,
            scope: 'openid'
        });

    }

})();

(function() {
  'use strict';

  angular
    .module('achat', ['infinicast']);

})();

'use strict';

angular.module('achat').value('UserSettings', {
    space: 'TPL_SPACE'
});

'use strict';

angular.module('achat').constant('ApplicationSettings', {
    cloudAddress: 'TPL_CLOUDADDRESS',
    clientId: 'TPL_OAUTH_CLIENT_ID',
    auth0Domain: 'bigpoint.eu.auth0.com',
    redirect_uri: 'TPL_REDIRECTURI',
	logoName: 'TPL_LOGONAME',
	game: 'TPL_GAME'
});

(function() {
  'use strict';

  angular
    .module('infinicast', []);

})();

'use strict';

/**
 * Angular wrapper for Infinicast
 *
 * This is actually a wrapper for Infinicast.
 * Purpose:
 * - Provide Infinicast as Angular service
 * - Allow to mock infinicast calls (try if it works!)
 * - Allows to work with promises
 *
 * Maybe we don't need this class at all
 */
angular.module('infinicast')
  .factory('infinicastManager', infinicastManager);

/*global Infinicast*/

function infinicastManager() {

  var infinicastManager = {};

  var connectors = {};

  infinicastManager.connectWithName = function(name, address, space, connectRole) {
    connectors[name] = new Infinicast.InfinicastClient();
    return connectors[name].connectAsync(address, space, connectRole)
  };

  infinicastManager.getByName = function(name) {
    return connectors[name];
  };


  return infinicastManager;
}

'use strict';

/**
 * Angular wrapper for Infinicast
 *
 * This is actually a wrapper for Infinicast.
 * Purpose:
 * - Provide Infinicast as Angular service
 * - Allow to mock infinicast calls (try if it works!)
 * - Allows to work with promises
 *
 * Maybe we don't need this class at all
 */
angular.module('infinicast')
  .factory('infinicast', infinicast);

/*global Infinicast*/

function infinicast($log, $q) {

  var _connector = new Infinicast.InfinicastClient();
  var _isConnected = false;

  _connector.OnDisconnect = function() {
    $log.debug("InfinicastService Disconnected");
    _isConnected = false;
  };

  return {

    /**
     * Connects to Afinity cloud
     * @param {string} address - Path of the Websocket server
     * @param {string} space - Space to use
     * @param {string} connectRole - Initial role to obtain
     */
    connect: function(address, space, connectRole) {
      // Create our own promise since API does not support it yet
      var connectPromise = $q.defer();

      Infinicast.Promise.Factory = function() {
        var result = {};
        result.promise = $q.defer();
        result.resolve = result.promise.resolve;
        result.reject = result.promise.reject;
        result.getData = function() {
          return result.promise.promise;
        };
        return result;
      };
      $log.debug("InfinicastService Connecting");
      _connector.connect(address, space, connectRole, function(errorInfo) {
        if (!errorInfo) {
          $log.debug("InfinicastService Connected");
          _isConnected = true;
          connectPromise.resolve();
        } else {
          $log.debug("InfinicastService Connect error", errorInfo);
          connectPromise.reject(errorInfo);
        }
      });

      return connectPromise.promise;
    },
    disconnect: function() {
      _connector.disconnect();
    },
    isConnected: function() {
      return _isConnected;
    },
    connector: function() {
      return _connector;
    },
    path: function(pathUri) {
      return _connector.path(pathUri);
    },
    getPath: function(pathAddress) {
      return _connector.path(pathAddress);
    }
  };
}

'use strict';

angular.module('achat')
  .factory('achatUserData', achatUserData);


function achatUserData(achat, infinicast, $q, $log) {
  var achatUserData = {};

  achatUserData.getAcpUserRolePrio = function(role) {
    switch (role) {
      case 'dev':
        return 5;
      case 'customerServiceLead':
        return 4;
      case 'customerService':
        return 3;
      case 'admin':
        return 2;
      case 'mod':
        return 1;
    }
    return 0;
  };

  achatUserData.changeOwnAccountInfo = function(data) {
    var future = $q.defer();
    infinicast.path('/acp/user/' + achat.user.playerId).modifyDataSetValue("info", data, function(error) {
      $log.log("changeOwnAccountInfo result", data, error);
      if (error) {
        future.reject();
      } else {
        future.resolve();
      }
    });
    return future.promise;
  };
  achatUserData.changeOtherUser = function(path, data) {
    var result = path.setDataAsync({
      info: data.info,
      role: data.role
    });
    return result;
  };
  achatUserData.deleteOtherUser = function(changedUser) {
    var result = changedUser.path.deleteDataAsync();
    return result;
  };

  achatUserData.getUserList = function() {
    var future = $q.defer();
    var thing = infinicast.path("/acp/user/getList").sendRequest({}, function (error, result) {
          if (!error) {

             console.log("received userList ",result);

             var resultList=[];
              result.list.forEach(function(ele){
                resultList.push({
                    data:ele,
                    path:infinicast.path('/acp/user/'+ele.userId+'/')
                });
              });
              future.resolve(resultList);
          } else {
              future.$$reject();
          }
      });
/*    var thing = infinicast.path('/acp/user/').children
    //.withDataContextRelative("online", "/presence/", "online")
      .toListAsync();

    $log.log('thing', thing);
    thing.then(function(result) {
      future.resolve(result.list);
    }, function(error) {
      $log.error("error", error);
      future.$$reject();
    });*/
    return future.promise;
  };
  return achatUserData;
}

'use strict';

angular.module('achat')
    .factory('aChatGlobal', aChatGlobal);


function aChatGlobal($rootScope) {
    var aChatGlobal = {};

    aChatGlobal.languageList = {
        'bg': 'Bulgarian',
        'br': 'Portuguese (Brasil)',
        'cn': 'Chinese',
        'cs': 'Czech',
        'da': 'Dansk',
        'de': 'German',
        'el': 'Greek',
        'en': 'English (UK)',
        'es': 'Spanish',
        'fi': 'Finnish',
        'fr': 'French',
        'hu': 'Hungarian',
        'it': 'Italian',
        'ja': 'Japanese',
        'nl': 'Dutch',
        'no': 'Norwegian',
        'kr': 'Korean',
        'pt': 'Portuguese',
        'pl': 'Polish',
        'ro': 'Romanian',
        'ru': 'Russian',
        'sk': 'Slovensky',
        'sv': 'Swedish',
        'tr': 'Turkish',
        'us': 'English (US)',
    };
    aChatGlobal.languageListOptions = [];
    for (var k in aChatGlobal.languageList) {
        var ob = {code: k};
        ob.title = aChatGlobal.languageList[k];
        aChatGlobal.languageListOptions.push(ob);
    }


    var settings = {};


    if (localStorage && localStorage.getItem) {
        settings.language = localStorage.getItem("language");
    }

    if (!settings.language) {
        settings.language = 'en';
    }

    $rootScope.selectedLanguageCode = settings.language;


    settings.instanceId = '';

    if (localStorage && localStorage.getItem) {
        settings.instanceId = localStorage.getItem("instanceId");
    }

    aChatGlobal.getInstanceId = function () {
        return settings.instanceId;
    };
    aChatGlobal.setInstanceId = function (instanceId) {
        settings.instanceId = instanceId;
        if (localStorage && localStorage.setItem) {
            localStorage.setItem("instanceId", instanceId);
        }
    };
    aChatGlobal.getSelectedLanguage = function () {
        return settings.language;
    };
    aChatGlobal.setSelectedLanguage = function (lan) {
        settings.language = lan;
        $rootScope.selectedLanguageCode = settings.language;
        if (localStorage && localStorage.setItem) {
            localStorage.setItem("language", lan);
        }
    };

    return aChatGlobal;
}

'use strict';

angular.module('achat')
    .factory('achatGameRooms', achatGameRooms);


function achatGameRooms(infinicast, $q, $log) {
    var achatGameRooms = {};


    achatGameRooms.listRooms = function (regex) {
        var roomsPromise = $q.defer();

        var result = {
            list: [],
            totalCount: 0
        };
        var addList = function (list) {
            if (list) {
                list.forEach(function (item) {
                    console.log('item', item.path.id, item);
                    var roomName = item.path.id;

                    var pathParams = item.path.extractPathParams("/room/$type/$id/");
                    //var language = item.pathAddressElement(3);
                    //    var server = item.pathAddressElement(4);
                    var type = pathParams["type"];
                    var fullText = type + " " + roomName;
                    result.list.push({
                        name: roomName,
                        //data: item.data,
                        type: type,
                        count: item.count,
                        fullText: fullText,
                        path: item.path
                    });
                    result.totalCount++;
                });
            }

        };

        var queriesPromises = [];

        var query = infinicast.path("/room/*/*/").pathByListeners;
        if(regex){
            query = query.withRegex(regex);
        }
        queriesPromises.push(query.toListAsync());
        $q.all(queriesPromises).then(function () {
            queriesPromises.forEach(function (promise) {

                /*eslint-disable*/
                if (promise.$$state && promise.$$state.value) {
                    console.log("adding list ", promise.$$state.value);
                    addList(promise.$$state.value.list);
                }
                /*eslint-enable*/
            });
            roomsPromise.resolve(result);
        }, function (error) {
            $log.error('could not fetch rooms', error);
            roomsPromise.reject();
        });
        return roomsPromise.promise;
    };


    return achatGameRooms;
}

'use strict';

angular.module('achat')
    .factory('achat', achat);


function achat($log, $q, $location, infinicast, ApplicationSettings, UserSettings, $rootScope) {

    function getRoomPath(name) {
        return infinicast.connector().path("Rooms/" + name);
    }

    function resolveFromErrorInfo(promise, errorInfo) {
        if (!errorInfo) {
            promise.resolve();
        } else {
            promise.reject(errorInfo);
        }
    }

    /**
     * Creates a completion handler that resolves a given promise depending
     * on a Infinicast errorInfo object
     */
    function promiseCompletionHandler(promise) {
        return resolveFromErrorInfo.bind(undefined, promise);
    }

    var cloudAddress = ApplicationSettings.cloudAddress;
    var achat_space = UserSettings.space;
    var achat_role = "cli.acp";
    var achat = {

        loginAndConnectDefer: $q.defer(),

        ensureLoginAndConnection: function () {
            return achat.loginAndConnectDefer.promise;
        },
        isLoggedIn: function () {
            return achat.ensureLoginAndConnection();
        },
        isActivatedUser: function () {
            $log.log("isActivatedUser called");
            var future = $q.defer();
            achat.ensureLoginAndConnection().then(function () {
                if (achat.user && achat.user.isActivated) {
                    $log.log("isActivatedUser resolved");
                    future.resolve();
                } else {
                    $log.log("isActivatedUser reject");
                    future.reject("notActivated");
                }
            }, function () {
                $log.log("isActivatedUser error");
                future.reject("notLoggedIn");
            });
            return future.promise;
        },
        connect: function (address, space, role) {
            return infinicast.connect(address, space, role);
        },

        disconnect: function () {
            return infinicast.disconnect();
        },

        isConnected: function () {
            return infinicast.isConnected();
        },

    connectAndLogin: function(redirect_uri, authorization_code) {
      $log.info('Login successful, auth_code = ' + authorization_code + ', connecting to cloud');
      achat.connect(cloudAddress, achat_space, achat_role).then(function() {
        $log.info("Connection to cloud successful");


        achat.login(redirect_uri, authorization_code).then(function(loginData) {

            if (loginData.playerId) {
                $log.log('successfully logged in ', loginData);
                achat.user = {
                    role: loginData.role,
                    info: loginData.info,
                    playerId: loginData.playerId
                };

                achat.serverList = [];

                if (loginData.initialServerList) {

                    achat.serverList = [];
                    var list = JSON.parse(loginData.initialServerList).list;
                    var alreadyExisting = {};
                    if (list) {
                        list.forEach(function (svr) {
                            svr.id = svr.id.substr(0,svr.id.indexOf("-"));
                            svr.displayName = svr.name + " " + svr.id;
                            if(!alreadyExisting[svr.displayName]){
                                achat.serverList.push(svr);
                                alreadyExisting[svr.displayName]=true;
                            }
                        });
                    }

                }

                achat.user.isActivated = loginData.activated;
                achat.user.isAcgrossGames = loginData.role == 'dev' || loginData.role == 'customerService' || loginData.role == 'customerServiceLead';
                $rootScope.loggedInUser = achat.user;
                achat.loginAndConnectDefer.resolve();

                // Go to specific page?
                var return_uri = localStorage.getItem('return_uri');
                if (return_uri) {
                    console.log('retuning to path ' + return_uri);
                    $location.path(return_uri).search({code: null, state: null});
                    localStorage.removeItem('return_uri');
                }
            } else {
                $log.log('login failed in service');
                achat.loginAndConnectDefer.reject("notLoggedIn");
            }

        }, function() {
            console.log('error logging in in service');
            achat.loginAndConnectDefer.reject("notLoggedIn");
        });
      }, function() {
          $log.error("Connecting to cloud via " + cloudAddress + " failed");
      });
    },

        login: function (redirect_uri, code) {
            var future = $q.defer();
            infinicast.path('/acp/auth/').sendRequest({
                code: code,
                redirect_uri: redirect_uri
            }, function (error, json, context) {
                $log.log('result for login ', error, json, context);

                if (!error && json) {
                    future.resolve(json);
                } else {
                    future.reject("notLoggedIn");
                }
            });
            return future.promise;
        },

        createRoom: function (name, isPublic) {
            var createRoomPromise = $q.defer();
            var roomPath = getRoomPath(name);
            var roomData = {
                isPublic: isPublic
            };
            roomPath.setData(roomData, function () {
                createRoomPromise.resolve();
            });
            return createRoomPromise.promise;
        },

        deleteRoom: function (name) {
            var returnPromise = $q.defer();
            var roomPath = getRoomPath(name);
            // Kick all listeners
            // Remove all chatter rights for this path
            // TODO
            // Clear data of this path
            //path.SetData({}, function() {
            //  returnPromise.resolve();
            //});
            // ??
            roomPath.delete(promiseCompletionHandler(returnPromise));
            return returnPromise.promise;
        },

        listenToChattersInRoom: function (roomName, onChange) {
            var returnPromise = $q.defer();
            var roomPath = getRoomPath(roomName);

            // unique id of endpoints to be used as object keys
            function endpointId(context) {
                return context.endpoint.toString();
            }

            // since we receive all listeners (also services), we have to
            // filter for chatters somehow
            function isChatter(context) {
                return !!context.endpointData && !!context.endpointData["nickName"];
            }

            // object id -> data of chatter
            var chatterMap = {};

            var handlerCollection = {
                OnListeningStarted: function (context) {
                    $log.debug("OnListeningStarted");
                    $log.debug(context);
                    if (isChatter(context)) {
                        chatterMap[endpointId(context)] = {
                            endpoint: context.endpoint,
                            data: context.endpointData
                        };
                        onChange(chatterMap);
                    }
                },
                OnListeningEnded: function (context) {
                    $log.debug("OnListeningEnded");
                    $log.debug(context);
                    if (isChatter(context)) {
                        delete chatterMap[endpointId(context)];
                        onChange(chatterMap);
                    }
                },
                OnListeningChanged: function (context) {
                    $log.debug("OnListeningChanged");
                    $log.debug(context);
                    if (isChatter(context)) {
                        chatterMap[endpointId(context)].data = context.endpointData;
                        onChange(chatterMap);
                    }
                }
            };
            if (onChange) {
                roomPath.listeners.live(handlerCollection.OnListeningStarted,
                    handlerCollection.OnListeningEnded,
                    handlerCollection.OnListeningChanged, null, promiseCompletionHandler(returnPromise));
            } else {
                // Unsubscribe
                roomPath.listeners.live(null, null, null, null, promiseCompletionHandler(returnPromise));
            }
            return returnPromise.promise;
        },

        listenToRoomMessages: function (roomName, onMessageHandler) {
            var returnPromise = $q.defer();
            var roomPath = getRoomPath(roomName);

            if (onMessageHandler) {
                var options = null;
                roomPath.onMessage(function (msgData, context) {

                    var args = {
                        roomName: roomName,
                        nickname: context.endpointData ? context.endpointData["nickName"] : null,
                        message: msgData["message"]
                    };
                    onMessageHandler(args);

                }, options, promiseCompletionHandler(returnPromise));
            } else {
                // Unsubscribe
                roomPath.onMessage(null, options, promiseCompletionHandler(returnPromise));
            }
            return returnPromise.promise;
        },

        getChattersInRoom: function (roomName) {
            var returnPromise = $q.defer();

            var roomPath = getRoomPath(roomName);
            roomPath.listeners.toList(function (errorInfo, resultList) { // , pathContext
                if (!errorInfo) {
                    console.log('recieved room list ', resultList);
                    returnPromise.resolve(resultList.items
                        // Throw out empty entries (Services are returned that have no nicks)
                            .filter(function (entry) {
                                return !!entry.data["nickName"];
                            })
                            // Wrap the result in our own object
                            .map(function (entry) {
                                return {
                                    endpoint: entry.endpoint,
                                    nickname: entry.data["nickName"]
                                };
                            })
                    );
                } else {
                    $log.warn("Could not fetch chatter list: " + errorInfo.message);
                    returnPromise.reject(errorInfo);
                }
            });
            return returnPromise.promise;

        },

        sendToRoom: function (roomName, message) {
            var returnPromise = $q.defer();

            var roomPath = getRoomPath(roomName);
            roomPath.sendMessage({
                message: message
            }, promiseCompletionHandler(returnPromise));

            return returnPromise.pomise;
        },


        getPossibleUserRoles: function () {
            var roleOptions = [];
            if (achat.user.role === 'dev') {
                roleOptions.push('dev');
                roleOptions.push('customerServiceLead');
                roleOptions.push('customerService');
                roleOptions.push('admin');
                roleOptions.push('mod');
            } else if (achat.user.role === 'customerServiceLead') {
                roleOptions.push('customerService');
                roleOptions.push('admin');
                roleOptions.push('mod');
            } else if (achat.user.role === 'customerService') {
                roleOptions.push('admin');
                roleOptions.push('mod');
            } else if (achat.user.role === 'admin') {
                roleOptions.push('mod');
            }
            return roleOptions;
        }
    };
    return achat;

}

'use strict';


angular.module('achat').filter('roleDisplay', function() {
  var map = {
    "dev": 'Chat Developer',
    "mod": 'Moderator',
    "admin": 'Admin',
    "customerService": 'Customer Service',
    "customerServiceLead": 'Customer Service Lead'
  };
  return function(role) {
    return map[role];

  }
});
angular.module('achat').filter('languageDisplay', function(aChatGlobal) {

  return function(language) {
    return aChatGlobal.languageList[language];
  }
});

angular.module('achat').filter('canEditRole', function(achat, achatUserData) {

  return function(roleToCheck) {

    return achat.user.role == 'dev' || achatUserData.getAcpUserRolePrio(achat.user.role) > achatUserData.getAcpUserRolePrio(roleToCheck)
  }
});

angular.module('achat').filter('timeAgo', function() {
  return function(unixTime) {
    /*global moment:true*/
    return moment(unixTime).fromNow();
  }
});
'use strict';


angular.module('achat').directive('achatUserDisplay', function (banModal,$rootScope) {
    return {
        restrict: 'AE',
        scope: {
            name: '@',
            mode: '@',
            clickable: '@',
            userid: '@',
            globalid: '@'
        },
        template: '<span ng-click="onClick()">' +
        '<span ng-if="mode==\'full\'">{{name}} uid:{{userid}} gid:{{globalid}}</span>' +
        '<span ng-if="mode!=\'full\'" title="uid:{{userid}} gid:{{globalid}}">{{name}}</span>' +
        '</span>',
        controller: function ($scope) {

            $scope.onClick = function () {
                if ($scope.clickable!=="false") {
                    banModal.open($rootScope.selectedLanguageCode, $scope.globalid,$scope.userid,$scope.name);
                }
            };

        }
    };
});

angular.module("achatdemo").run(["$templateCache", function($templateCache) {$templateCache.put("app/callback/callback.html","&nbsp;");
$templateCache.put("app/discipline/disciplines.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"ibox\"><div class=\"ibox-content\"><h2>Disciplines</h2><h3>Username</h3><input type=\"text\" ng-model=\"disciplines.query.userName\" class=\"input form-control\"><h3>GlobalId</h3><input type=\"text\" ng-model=\"disciplines.query.globalId\" class=\"input form-control\"><h3>UserId</h3><input type=\"text\" ng-model=\"disciplines.query.userId\" class=\"input form-control\"> <button type=\"button\" class=\"btn btn btn-primary\" ng-if=\"disciplines.query.userName.length>0||disciplines.query.globalId.length>0||disciplines.query.userId.length>0\" ng-click=\"disciplines.searchUserDiscipline()\"><i class=\"fa fa-search\"></i> Search <span>filtered by</span> <span ng-if=\"disciplines.query.userName.length>0\">Name</span> <span ng-if=\"disciplines.query.globalId.length>0 && (!(disciplines.query.userName.length>0))\">Global Id</span> <span ng-if=\"disciplines.query.userId.length>0 && (!(disciplines.query.userName.length>0)) && (!(disciplines.query.globalId.length>0))\">User Id</span></button></div></div></div><div class=\"col-sm-9\"><div class=\"ibox chat-view\" ng-if=\"disciplines.selectedDiscipline && disciplines.selectedDiscipline.globalId\"><div class=\"ibox-title\">User<achat-user-display style=\"padding-left:10px;\" name=\"{{disciplines.selectedDiscipline.name}}\" userid=\"{{disciplines.selectedDiscipline.userId}}\" globalid=\"{{disciplines.selectedDiscipline.globalId}}\"></achat-user-display></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-9\"><div ng-if=\"disciplines.selectedDiscipline\" class=\"chat-discussion\" id=\"chat-discussion\"><div class=\"chat-message\"><div class=\"message\"><span class=\"message-content\"><strong>Until:</strong> {{disciplines.selectedDiscipline.data.until | date:\'dd.MM.yy HH:mm\'}}</span> <span class=\"message-content\"><strong>Reason:</strong> {{disciplines.selectedDiscipline.data.reason}}</span><span class=\"message-content\"><strong>By:</strong> {{disciplines.selectedDiscipline.data.byName}} {{disciplines.selectedDiscipline.data.by}}</span></div></div></div></div><div class=\"col-md-3\"><div class=\"row\"><button class=\"btn btn-sm btn-primary\" type=\"submit\" ng-click=\"disciplines.unban()\"><strong>Unban</strong></button></div></div></div></div></div><div class=\"ibox chat-view\"><div class=\"ibox-title\"><button style=\"float:right;\" type=\"button\" class=\"btn btn btn-primary btn-xs\" ng-click=\"disciplines.updateRecentList()\"><i class=\"fa fa-search\"></i> Update</button> Recent Disciplines</div><table class=\"table table-striped table-hover\"><table><tr><th>Time</th><th>Until</th><th>User</th><th>Reason</th><th>By</th></tr><tr ng-repeat=\"recent in disciplines.recentList\"><td style=\"padding-right:10px;\">{{recent.time| date:\'dd.MM.yy H:mm:ss\'}}</td><td style=\"padding-right:10px;\">{{recent.until| date:\'dd.MM.yy H:mm:ss\'}}</td><td style=\"padding-right:10px;\"><achat-user-display name=\"{{recent.name}}\" userid=\"{{recent.userId}}\" globalid=\"{{recent.globalId}}\" ng-click=\"disciplines.selectRecent(recent)\"></achat-user-display></td><td style=\"padding-right:10px;\">{{recent.reason}}</td><td>{{recent.byName}} {{recent.by}}</td></tr></table></table></div></div></div></div>");
$templateCache.put("app/discipline/reports.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"ibox\"><div class=\"ibox-title\"><button style=\"float:right;\" type=\"button\" class=\"btn btn btn-primary btn-xs\" ng-click=\"reports.updateList()\"><i class=\"fa fa-search\"></i> Update</button><h2>Reports [{{selectedLanguageCode}}]</h2></div><div class=\"ibox-content\" ng-style=\"{height:stdContentHeight}\"><input type=\"text\" placeholder=\"filter\" class=\"input form-control\" ng-model=\"reports.filter\"><div class=\"full-height-scroll\" full-scroll=\"\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"report in reports.filteredList|orderBy:\'data.reportCount\':true\" ng-click=\"reports.selectedReport = report\"><td>{{report.name}} {{report.userId}} {{report.globalId}} <b>[{{report.data.reportCount}}]</b></td></tr></tbody></table></div></div></div></div></div><div class=\"col-sm-9\"><div class=\"ibox\"><div class=\"ibox-title\" ng-if=\"reports.selectedReport.globalId\"><h2>Reports for User<achat-user-display style=\"padding-left:4px;\" name=\"{{reports.selectedReport.name}}\" userid=\"{{reports.selectedReport.userId}}\" globalid=\"{{reports.selectedReport.globalId}}\"></achat-user-display></h2></div><div class=\"ibox-title\" ng-if=\"!reports.selectedReport.globalId\"><h2>No user selected.</h2></div><div class=\"ibox-content\" ng-style=\"{\'min-height\':stdContentHeight}\"><div class=\"row full-height\"><div class=\"col-md-7 full-height\"><div class=\"chat-discussion\"><div class=\"chat-message\" ng-repeat=\"report in reports.selectedReport.data.reportList\"><div class=\"message\"><span class=\"message-date\">{{report.time | date:\'short\'}} by<achat-user-display name=\"{{report.reporterName}}\" userid=\"{{report.reporter}}\" globalid=\"{{report.reporterGlobalId}}\"></achat-user-display></span> <span class=\"message-content\"><strong>Reason:</strong> {{report.reason}}</span><div><strong>Room:</strong> {{report.room}}</div><div><strong>Chat:</strong><div ng-repeat=\"txt in report.msgs\">{{txt}}</div></div><div><strong>Reporter:</strong><achat-user-display name=\"{{report.reporterNickname}}\" userid=\"{{report.reporterUserid}}\" globalid=\"{{report.reporterGlobalId}}\"></achat-user-display></div></div></div><div class=\"chat-message left\" ng-repeat=\"message in reports.reportMessages\"><div class=\"message\"><a class=\"message-author\" href=\"#\">{{message.nickname}}</a> <span class=\"message-date\">{{message.timestamp | date:\'short\'}}</span> <span class=\"message-content\">{{message.message}}</span></div></div></div></div><div class=\"col-md-5\"><div class=\"row\"><div ng-if=\"reports.selectedReport\"><h4>Actions for<achat-user-display name=\"{{reports.selectedReport.name}}\" userid=\"{{reports.selectedReport.userId}}\" globalid=\"{{reports.selectedReport.globalId}}\"></achat-user-display></h4><button class=\"btn btn-sm btn-primary\" type=\"submit\" ng-click=\"reports.markResolved()\"><strong>Mark Report as resolved</strong></button><br><br><button class=\"btn btn-sm btn-primary\" type=\"submit\" ng-click=\"reports.ban()\"><strong>Open Ban Dialog</strong></button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/error/notActivated.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h1>User is not activated</h1></div></div><div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"NotActivatedController as ctrl\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Please <a href=\"mailto:achat_admin@bigpoint.net\">contact</a> an admin to receive an invite for the chat ACP</h5></div></div></div></div></div>");
$templateCache.put("app/error/notLoggedIn.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h1>Could not Login</h1></div></div><div class=\"wrapper wrapper-content animated fadeIn\"><h3>Could not login as Bigpoint User.</h3>Please try again later.</div>");
$templateCache.put("app/gsMonitoring/gsMonitoring.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"GsMonitoringController as monitoring\"><div class=\"ibox\"><div class=\"ibox-content\"><h2>Production GS Monitoring</h2><div ng-if=\"problematicServers.length>0\"><h3>Problematic Servers</h3><b style=\"color:#ee1100\">{{problematicServers}}</b></div><h3>All Gameservers</h3><label><input type=\"text\" ng-model=\"filter.filterTxt\"> Filter by instance name, instance id or error(just enter error)</label><br><br><table><tr><th ng-click=\"order.field=\'instanceId\'\"><i class=\"fa fa-sort-asc\" ng-if=\"order.field==\'instanceId\'\"></i> Id</th><th ng-click=\"order.field=\'instanceName\'\"><i class=\"fa fa-sort-asc\" ng-if=\"order.field==\'instanceName\'\"></i> Name</th><th ng-click=\"order.field=\'timeSinceKeepAlive\'\"><i class=\"fa fa-sort-asc\" ng-if=\"order.field==\'timeSinceKeepAlive\'\"></i> Last Update(Minutes)</th><th>Valid</th></tr><tr ng-repeat=\"server in servers | orderBy:order.field|filter:filter\"><td>{{server.instanceId}}</td><td>{{server.instanceName}}</td><td>{{server.timeSinceKeepAliveText}}</td><td>{{server.valid}}</td></tr></table></div></div></div>");
$templateCache.put("app/history/history.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"HistoryController as history\"><div class=\"row\"><div class=\"col-sm-5\"><div class=\"ibox\"><div class=\"ibox-content\"><h2>History</h2><h3>Time Frame</h3><input type=\"text\" class=\"daterange input form-control\"><h3>Username</h3><input type=\"text\" ng-model=\"history.query.userName\" class=\"input form-control\"><h3>GlobalId</h3><input type=\"text\" ng-model=\"history.query.globalId\" class=\"input form-control\"><h3>UserId</h3><input type=\"text\" ng-model=\"history.query.userId\" class=\"input form-control\"><h3>Room</h3><table><tr><td><select ng-model=\"history.query.roomType\" class=\"input form-control\"><option value=\"sys\">System</option><option value=\"dyn\">Dynamic</option><option value=\"usr\">User</option><option value=\"std\">Standard</option></select></td><td><input type=\"text\" ng-model=\"history.query.room\" class=\"input form-control\"></td></tr></table><hr><button type=\"button\" class=\"btn btn btn-primary\" ng-click=\"history.searchHistory()\"><i class=\"fa fa-search\"></i> Search <span ng-if=\"history.query.room.length>0||history.query.userId.length>0||history.query.userName.length>0||history.query.globalId.length>0\">filtered by <span ng-if=\"history.query.room.length>0\">Room</span> <span ng-if=\"history.query.room.length>0 && (history.query.userName.length>0||history.query.globalId.length>0)\">&</span> <span ng-if=\"history.query.userName.length>0\">Name</span></span> <span ng-if=\"history.query.globalId.length>0 && (!(history.query.userName.length>0))\">Global Id</span> <span ng-if=\"history.query.userId.length>0 && (!(history.query.userName.length>0)) && (!(history.query.globalId.length>0))\">User Id</span></button></div></div></div><div class=\"col-sm-7\"><div class=\"ibox chat-view\"><div class=\"ibox-title\" ng-if=\"!history.historyRooms.length\">No results found</div><div class=\"ibox-title\" ng-if=\"history.historyRooms.length\">{{history.totalResults}} total Results</div><uib-tabset active=\"active\"><uib-tab ng-repeat=\"room in history.historyRooms\"><uib-tab-heading>{{room.name}}</uib-tab-heading><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"chat-discussion\" id=\"chat-discussion\"><div class=\"chat-message left\" ng-repeat=\"msg in room.messages\" ng-click=\"history.selectUserByMessage(msg)\"><div class=\"message\"><a class=\"message-author\"><achat-user-display clickable=\"false\" name=\"{{msg.data.nickName}}\" userid=\"{{msg.data.userId}}\" globalid=\"{{msg.data.globalId}}\"></achat-user-display></a> <span class=\"message-date\">{{msg.data.date | date:\'short\'}}</span> <span class=\"message-content\">{{msg.data.msg}}</span></div></div></div></div></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/invites/invite.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"InviteController as ctrl\"><div class=\"row\"><div class=\"col-sm-8\"><div class=\"ibox\"><div class=\"ibox-content\"><div ng-if=\"ctrl.state==\'loading\'\">trying to activate your token {{ctrl.token}}.<br></div><div ng-if=\"ctrl.state==\'success\'\">successfully activated your token {{ctrl.token}}.<br>Please reload the page.</div><div ng-if=\"ctrl.state==\'error\'\">Invalid token {{ctrl.token}}.<br>The token might already be used. Please try if you can login already.<br><a href=\"/#\">continue to ACP</a></div></div></div></div></div></div>");
$templateCache.put("app/layout/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/layout/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/layout/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/layout/footer.html\'\"></div></div></div>");
$templateCache.put("app/layout/error.html","<div id=\"wrapper\"><nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"logo-element\">{{ACPName}}</div></li></ul></div></nav><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ui-view=\"\"></div><div ng-include=\"\'app/layout/footer.html\'\"></div></div></div>");
$templateCache.put("app/layout/footer.html","<div class=\"footer\"><div class=\"pull-right\">Ready.</div><div><strong>Copyright</strong> Bigpoint GmbH &copy; 2017 - 2021</div></div>");
$templateCache.put("app/layout/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/layout/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\" ng-controller=\"MainController as mainCtrl\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div ng-if=\"mainCtrl.auth.isAuthenticated()\" class=\"profile-element\" uib-dropdown=\"\"><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li><a ng-click=\"mainCtrl.logout();\">Logout</a></li></ul><a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">{{mainCtrl.user.info.email}}</strong><b class=\"caret\"></b></span> <span class=\"text-muted text-xs block\">{{mainCtrl.user.role|roleDisplay}}</span></span></a></div><div class=\"logo-element\">{{mainCtrl.logoName}}</div></li><li ng-if=\"mainCtrl.auth.isAuthenticated()\" ui-sref-active=\"active\"><a ui-sref=\"user.list\"><i class=\"fa fa-users\"></i> <span class=\"nav-label\">Admins</span></a></li><li ng-if=\"mainCtrl.auth.isAuthenticated()\" ui-sref-active=\"active\"><a ui-sref=\"rooms.index\"><i class=\"fa fa-comment\"></i> <span class=\"nav-label\">Chat</span></a></li><li ng-if=\"mainCtrl.auth.isAuthenticated()\" ui-sref-active=\"active\"><a ui-sref=\"discipline.reports\"><i class=\"fa fa-flag\"></i> <span class=\"nav-label\">Report</span></a></li><li ng-if=\"mainCtrl.auth.isAuthenticated()\" ui-sref-active=\"active\"><a ui-sref=\"discipline.disciplines\"><i class=\"fa fa-hand-pointer-o\"></i> <span class=\"nav-label\">Disciplines</span></a></li><li ng-if=\"mainCtrl.auth.isAuthenticated()\" ui-sref-active=\"active\"><a ui-sref=\"wordFilter.list\"><i class=\"fa fa-comment\"></i> <span class=\"nav-label\">Word Filter</span></a></li><li ng-if=\"mainCtrl.auth.isAuthenticated()\" ui-sref-active=\"active\"><a ui-sref=\"history.index\"><i class=\"fa fa-comment\"></i> <span class=\"nav-label\">History</span></a></li><li ng-if=\"mainCtrl.auth.isAuthenticated() && loggedInUser.role==\'dev\'\" ui-sref-active=\"active\"><a ui-sref=\"gsMonitoring.index\"><i class=\"fa fa-comment\"></i> <span class=\"nav-label\">GS Monitoring</span></a></li></ul></div></nav>");
$templateCache.put("app/layout/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\" ng-controller=\"MainController as mainCtrl\"><div class=\"navbar-header\"><form role=\"search\" class=\"navbar-form-custom\" method=\"post\" action=\"\"><table style=\"width:310px;margin-left:10px;\"><tr><td><label>Selected Language</label></td><td><select class=\"form-control\" ng-options=\"item.code as item.title for item in mainCtrl.languageListOptions\" ng-change=\"mainCtrl.languageChanged()\" ng-model=\"mainCtrl.selectedLanguage\"></select></td></tr></table></form></div><ul class=\"nav navbar-top-links navbar-right\"><li><a ng-if=\"!mainCtrl.auth.isAuthenticated()\" ng-click=\"mainCtrl.auth.login()\"><i class=\"fa fa-sign-in\"></i> Login</a></li><li><a ng-if=\"mainCtrl.auth.isAuthenticated()\" ng-click=\"mainCtrl.auth.logout()\"><i class=\"fa fa-sign-out\"></i> Logout</a></li></ul></nav></div>");
$templateCache.put("app/rooms/list.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"RoomsController as rooms\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"ibox\"><div class=\"ibox-title\" ng-if=\"rooms.globalRooms.length > 0\"><h3>Global Rooms</h3></div><div class=\"ibox-content\" ng-if=\"rooms.globalRooms.length > 0\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"room in rooms.globalRooms\" ng-click=\"rooms.openRoom(room, null, false)\"><td>{{room}}</td></tr></tbody></table></div><div class=\"ibox-title\" ng-if=\"rooms.globalLocalizedRooms.length > 0\"><h3>Global Rooms [{{selectedLanguageCode}}]</h3></div><div class=\"ibox-content\" ng-if=\"rooms.globalLocalizedRooms.length > 0\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"room in rooms.globalLocalizedRooms\" ng-click=\"rooms.openRoom(room, null, true)\"><td>{{room}} - {{selectedLanguageCode}}</td></tr></tbody></table></div><div class=\"ibox-title\"><h3>Static Instance Rooms [{{selectedLanguageCode}}]</h3></div><div class=\"ibox-content\"><div class=\"full-height-scroll\" full-scroll=\"\"><h4>Select Instance</h4><select class=\"form-control\" ng-options=\"item.id as item.displayName for item in rooms.instanceList\" ng-model=\"rooms.instanceId\" ng-change=\"rooms.instanceIdChanged()\"></select><input type=\"text\" placeholder=\"InstanceId\" class=\"input form-control\" ng-model=\"rooms.instanceId\" ng-change=\"rooms.instanceIdChanged()\"><br><div class=\"table-responsive\" ng-if=\"rooms.instanceId\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"room in rooms.staticRooms\" ng-click=\"rooms.openRoomNew(room, rooms.instanceId, true)\"><td>{{rooms.getRoomText(rooms.instanceId,room,selectedLanguageCode)}}</td></tr></tbody></table></div></div></div><div class=\"ibox-title\"><h3>Dynamic Instance Rooms</h3></div><div class=\"ibox-content\"><select class=\"form-control\" ng-model=\"rooms.roomType\" ng-change=\"rooms.refresh()\" ng-options=\"item as item.name for item in rooms.roomTypes\"></select><div ng-if=\"rooms.roomType\"><div class=\"input-group\"><input type=\"text\" placeholder=\"Filter rooms\" class=\"input form-control\" ng-model=\"rooms.filter\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"rooms.refresh()\"><i class=\"fa fa-search\"></i> Refresh</button></span></div><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"room in rooms.filteredList\" ng-click=\"rooms.openRoomObject(room)\"><td>{{room.displayName}}</td></tr></tbody></table></div></div></div></div><div class=\"col-sm-9\"><div class=\"ibox chat-view\" ng-if=\"rooms.roomService.openRooms.length==0\"><h3>No room Selected</h3></div><div class=\"ibox chat-view\" ng-if=\"rooms.roomService.openRooms.length>0\"><uib-tabset active=\"rooms.roomService.activeTab\"><uib-tab ng-repeat=\"room in rooms.roomService.openRooms\" active=\"room.active\" select=\"rooms.changeTab(room)\"><uib-tab-heading>{{room.name}} {{room.openMessages}}</uib-tab-heading><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-9\"><div ng-class=\"{selected:rooms.roomService.selectedRoom==room}\" class=\"chat-discussion\" ng-style=\"{height:stdContentHeight-44}\"><div class=\"left\" ng-repeat=\"message in room.roomMessages\" ng-click=\"rooms.chat.openUserByMessage(message)\"><i>{{message.timestamp | date:\'H:mm:ss\'}}</i> <span ng-style=\"{color:message.userColor}\"><achat-user-display clickable=\"false\" name=\"{{message.nickname}}\" userid=\"{{message.userId}}\" globalid=\"{{message.globalId}}\"></achat-user-display></span><span ng-if=\"message.role\">[{{message.role}}]</span>: {{message.msg}}</div></div></div><div class=\"col-md-3\"><div class=\"chat-users\"><button style=\"float:right;margin-right:10px;\" class=\"btn btn-primary btn-xs\" ng-click=\"rooms.closeRoom(room)\">Close</button><div class=\"users-list\"><br><input type=\"text\" placeholder=\"Filter Id / Global Id\" class=\"input form-control\" ng-model=\"room.filter\" ng-change=\"room.filterChanged()\"><br><h3 style=\"padding-left:10px;\">Chatting Mods</h3><div class=\"chat-user\" ng-repeat=\"user in room.filteredChattingMods\"><span class=\"chat-user-name\"><a ng-style=\"{color:user.color}\">{{user.userId}}</a>[{{user.role}}]</span></div><h3 style=\"padding-left:10px;\">Chatting Users</h3><div class=\"chat-user\" ng-repeat=\"user in room.filteredChattingUsers\"><span class=\"chat-user-name\"><a ng-style=\"{color:user.color}\"><achat-user-display name=\"{{user.nickname}}\" userid=\"{{user.userId}}\" globalid=\"{{user.globalId}}\"></achat-user-display></a>[{{user.role}}]</span><div class=\"btn-group\"><button class=\"btn btn-primary btn-xs\" ng-click=\"rooms.banUser(user)\">Ban</button></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-8\"><div class=\"chat-message-form\"><div class=\"form-group\"><input class=\"form-control message-input\" type=\"text\" name=\"message\" placeholder=\"Enter message text\" ng-model=\"rooms.chat.inputLine\" ng-keyup=\"$event.keyCode == 13 ? rooms.chat.send(room,rooms.chat.inputLine) : null\"></div></div></div><div class=\"col-lg-4\">Autoscroll <input type=\"checkbox\" ng-model=\"rooms.roomService.autoScroll\"></div></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/user/addNew.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-content\" ng-show=\"finished\"><h2>Invite added</h2><div>Invite Url:</div><div><input class=\"form-control\" type=\"text\" ng-model=\"inviteUrl\"></div><div><br><button class=\"btn btn-sm\" type=\"submit\" ng-click=\"close()\"><strong>Ok</strong></button></div></div><div class=\"ibox-content\" ng-show=\"!finished\"><h2>Add new User</h2><form name=\"inviteForm\" class=\"ng-pristine ng-valid\" role=\"form\" novalidate=\"\"><div class=\"form-group required\" show-errors=\"\"><label>Role</label><select name=\"role\" class=\"form-control\" ng-options=\"item as (item|roleDisplay) for item in roleOptions\" ng-model=\"editData.role\" required=\"\"></select><p class=\"help-block\" ng-if=\"inviteForm.role.$error.required\">The role is not chosen</p></div><div class=\"form-group\"><label>Email</label> <input name=\"email\" placeholder=\"Enter email\" class=\"form-control\" type=\"email\" ng-model=\"editData.info.email\"></div><div class=\"form-group\"><label class=\"control-label\">Nickname</label> <input placeholder=\"Enter nickname\" class=\"form-control\" type=\"text\" ng-model=\"editData.info.nickName\"></div><div class=\"form-group required\" show-errors=\"\"><label class=\"control-label\">Firstname</label> <input name=\"firstname\" placeholder=\"Enter firstname\" class=\"form-control\" type=\"text\" ng-model=\"editData.info.firstname\" required=\"\"><p class=\"help-block\" ng-if=\"inviteForm.firstname.$error.required\">The firstname is empty</p></div><div class=\"form-group required\" show-errors=\"\"><label class=\"control-label\">Lastname</label> <input name=\"lastname\" placeholder=\"Enter lastname\" class=\"form-control\" type=\"text\" ng-model=\"editData.info.lastname\" required=\"\"><p class=\"help-block\" ng-if=\"inviteForm.lastname.$error.required\">The lastname is empty</p></div><div class=\"form-group\"><label>Birthday</label> <input placeholder=\"Enter Birthday\" class=\"form-control\" type=\"text\" ng-model=\"editData.info.birthday\"></div><div class=\"form-group\"><label>Notice</label> <input placeholder=\"Enter Notice\" class=\"form-control\" type=\"text\" ng-model=\"editData.info.notice\"></div><div class=\"form-group\"><label>HT Access Login name</label> <input placeholder=\"Enter HT Access Login Name\" class=\"form-control\" type=\"text\" ng-model=\"editData.info.htAccessLogin\"></div><div class=\"form-group\"><label>Language</label><select class=\"form-control\" ng-options=\"item.code as item.title for item in languageListOptions\" ng-model=\"editData.info.language\"></select></div><div><button class=\"btn btn-sm btn-primary m-t-n-xs\" type=\"submit\" ng-click=\"submitNewUser()\"><strong>Submit</strong></button> <button class=\"btn btn-sm m-t-n-xs\" type=\"submit\" ng-click=\"close()\"><strong>Cancel</strong></button></div></form></div></div></div></div></div>");
$templateCache.put("app/user/userList.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"UserListController as userCtrl\"><div class=\"row\"><div class=\"col-sm-8\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><h2>Admins</h2></div><div class=\"col-sm-6\"><button tpye=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"userCtrl.addNewUser()\">Invite User</button></div></div><div class=\"input-group\"><input type=\"text\" placeholder=\"Filters\" class=\"input form-control\" ng-model=\"userCtrl.filter\"> <span>Possible filters: Language code, Role type, Username</span></div><div class=\"clients-list\"><h3>Active Users</h3><div class=\"table-responsive\"><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"user in userCtrl.filteredList |orderBy:\'orderText\'\" ng-click=\"userCtrl.selectUser(user)\"><td class=\"client-avatar\"><img alt=\"image\" src=\"assets/images/demo/a1.jpg\"></td><td><a class=\"client-link\">{{user.info.firstname}} {{user.info.lastname}}</a></td><td>{{user.role|roleDisplay}}</td><td>{{user.info.language}}</td><td>{{user.info.email}}</td><td class=\"client-status\"><span ng-if=\"user.online\" class=\"label label-primary\">Online</span></td></tr></tbody></table></div><div class=\"table-responsive\" ng-if=\"userCtrl.invitedUsers.length>0\"><h3>Open Invites:</h3><table class=\"table table-striped table-hover\"><tbody><tr ng-repeat=\"user in userCtrl.invitedUsers\" ng-click=\"userCtrl.selectInvite(user)\"><td class=\"client-avatar\"><img alt=\"image\" src=\"assets/images/demo/a1.jpg\"></td><td><a class=\"client-link\">{{user.data.info.firstname}} {{user.data.info.lastname}}</a></td><td>{{user.data.role|roleDisplay}}</td><td>{{user.data.info.language}}</td><td>{{user.data.info.email}}</td></tr></tbody></table></div></div></div></div></div><div class=\"col-sm-4\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"tab-content\"><div id=\"contact-1\" class=\"tab-pane active\"><div class=\"client-detail\" ng-show=\"userCtrl.selectedInviteUser\"><h2>Invite: {{userCtrl.selectedInviteUser.data.info.firstname}} {{userCtrl.selectedInviteUser.data.info.lastname}} [{{userCtrl.selectedInviteUser.data.info.nickName}}] <button type=\"button\" class=\"btn btn-sm btn-danger pull-right\" ng-disabled=\"!(userCtrl.selectedInviteUser.role|canEditRole)\" ng-click=\"userCtrl.deleteInvitedUser()\"><i class=\"fa fa-trash\"></i> Delete</button></h2><div>Usable until: {{userCtrl.selectedInviteUser.data.until|date:\'short\'}}</div></div><div class=\"client-detail\" ng-show=\"userCtrl.selectedUser\"><div class=\"full-height-scroll\" full-scroll=\"\"><h2>{{userCtrl.selectedUser.info.firstname}} {{userCtrl.selectedUser.info.lastname}} [{{userCtrl.selectedUser.info.nickName}}]</h2><button type=\"button\" class=\"btn btn-sm btn-danger pull-right\" ng-show=\"(!userCtrl.selectedUser.isThisUser||(userCtrl.selectedUser.role|canEditRole))&&!userCtrl.selectedUser.$editing\" ng-disabled=\"!(userCtrl.selectedUser.role|canEditRole)\" ng-click=\"userCtrl.deleteSelectedUser()\"><i class=\"fa fa-trash\"></i> Delete</button> <button type=\"button\" class=\"btn btn-sm btn-primary pull-right\" ng-show=\"(!userCtrl.selectedUser.isThisUser||(userCtrl.selectedUser.role|canEditRole))&&!userCtrl.selectedUser.$editing\" ng-disabled=\"!(userCtrl.selectedUser.role|canEditRole)\" ng-click=\"userCtrl.selectedUser.$editing=true;userCtrl.startEditing()\"><i class=\"fa fa-edit\"></i> Edit</button> <button type=\"button\" class=\"btn btn-sm btn-primary pull-right\" ng-show=\"userCtrl.selectedUser.isThisUser&&!userCtrl.selectedUser.$editingMySelf\" ng-click=\"userCtrl.selectedUser.$editingMySelf=true;userCtrl.startEditing()\"><i class=\"fa fa-edit\"></i> Edit Yourself</button><div ng-show=\"!userCtrl.selectedUser.$editing && !userCtrl.selectedUser.$editingMySelf\"><h4>Role</h4><div>{{userCtrl.selectedUser.role|roleDisplay}}</div><h4>Email</h4><div>{{userCtrl.selectedUser.info.email}}</div><h4>Language</h4><div>{{userCtrl.selectedUser.info.language|languageDisplay}}</div><h4 ng-if=\"userCtrl.selectedUser.info.notice\">Notice</h4><div>{{userCtrl.selectedUser.info.notice}}</div><h4 ng-if=\"userCtrl.selectedUser.info.htAccessLogin\">HT Access Login Name</h4><div>{{userCtrl.selectedUser.info.htAccessLogin}}</div></div><form class=\"ng-pristine ng-valid\" role=\"form\" ng-show=\"userCtrl.selectedUser.$editingMySelf\"><div class=\"form-group\"><label>Email</label> <input placeholder=\"Enter email\" class=\"form-control\" type=\"email\" ng-model=\"userCtrl.editData.info.email\"></div><div class=\"form-group\"><label>Nickname</label> <input placeholder=\"Enter nickname\" class=\"form-control\" type=\"text\" ng-model=\"userCtrl.editData.info.nickName\"></div><div class=\"form-group\"><label>Firstname</label> <input placeholder=\"Enter firstname\" class=\"form-control\" type=\"text\" ng-model=\"userCtrl.editData.info.firstname\"></div><div class=\"form-group\"><label>Lastname</label> <input placeholder=\"Enter lastname\" class=\"form-control\" type=\"text\" ng-model=\"userCtrl.editData.info.lastname\"></div><div class=\"form-group\"><label>Birthday</label> <input placeholder=\"Enter Birthday\" class=\"form-control\" type=\"text\" ng-model=\"userCtrl.editData.info.birthday\"></div><div class=\"form-group\"><label>HT Access Login name</label> <input placeholder=\"Enter HT Access Login Name\" class=\"form-control\" type=\"text\" ng-model=\"userCtrl.editData.info.htAccessLogin\"></div><div class=\"form-group\"><label>Language</label><select class=\"form-control\" ng-options=\"item.code as item.title for item in userCtrl.languageListOptions\" ng-model=\"userCtrl.editData.info.language\"></select></div><div><button class=\"btn btn-sm btn-primary m-t-n-xs\" type=\"submit\" ng-click=\"userCtrl.submitChanges()\"><strong>Submit your own info</strong></button> <button class=\"btn btn-sm m-t-n-xs\" type=\"submit\" ng-click=\"userCtrl.selectedUser.$editingMySelf=false\"><strong>Cancel</strong></button></div></form><form class=\"ng-pristine ng-valid\" role=\"form\" ng-show=\"userCtrl.selectedUser.$editing\"><div class=\"form-group\"><label>Role</label><select class=\"form-control\" ng-options=\"item as (item|roleDisplay) for item in userCtrl.roleOptions\" ng-model=\"userCtrl.editData.role\"></select></div><div class=\"form-group\"><label>Email</label> <input placeholder=\"Enter email\" class=\"form-control\" type=\"email\" ng-model=\"userCtrl.editData.info.email\"></div><div class=\"form-group\"><label>Nickname</label> <input placeholder=\"Enter nickname\" class=\"form-control\" type=\"text\" ng-model=\"userCtrl.editData.info.nickName\"></div><div class=\"form-group\"><label>Firstname</label> <input placeholder=\"Enter firstname\" class=\"form-control\" type=\"text\" ng-model=\"userCtrl.editData.info.firstname\"></div><div class=\"form-group\"><label>Lastname</label> <input placeholder=\"Enter lastname\" class=\"form-control\" type=\"text\" ng-model=\"userCtrl.editData.info.lastname\"></div><div class=\"form-group\"><label>Birthday</label> <input placeholder=\"Enter Birthday\" class=\"form-control\" type=\"text\" ng-model=\"userCtrl.editData.info.birthday\"></div><div class=\"form-group\"><label>Notice</label> <input placeholder=\"Enter Notice\" class=\"form-control\" type=\"text\" ng-model=\"userCtrl.editData.info.notice\"></div><div class=\"form-group\"><label>HT Access Login name</label> <input placeholder=\"Enter HT Access Login Name\" class=\"form-control\" type=\"text\" ng-model=\"userCtrl.editData.info.htAccessLogin\"></div><div class=\"form-group\"><label>Language</label><select class=\"form-control\" ng-options=\"item.code as item.title for item in userCtrl.languageListOptions\" ng-model=\"userCtrl.editData.info.language\"></select></div><div><button class=\"btn btn-sm btn-primary m-t-n-xs\" type=\"submit\" ng-click=\"userCtrl.submitChanges()\"><strong>Submit</strong></button> <button class=\"btn btn-sm m-t-n-xs\" type=\"submit\" ng-click=\"userCtrl.selectedUser.$editing=false\"><strong>Cancel</strong></button></div></form><hr><div ng-if=\"userCtrl.canSeeAuditLogs\"><strong>Timeline activity</strong><div ng-if=\"!userCtrl.auditResults.length\">no recent activity</div><div id=\"vertical-timeline\" class=\"vertical-container dark-timeline\"><div class=\"vertical-timeline-block\" ng-repeat=\"ele in userCtrl.auditResults|orderBy:\'data.time\':true\"><div class=\"vertical-timeline-icon gray-bg\"><i class=\"fa fa-sign-in\" ng-if=\"ele.data.type==\'invite\'\"></i> <i class=\"fa fa-sign-in\" ng-if=\"ele.data.type==\'login\'\"></i> <i class=\"fa fa-sign-out\" ng-if=\"ele.data.type==\'logout\'\"></i> <i class=\"fa fa-pencil\" ng-if=\"ele.data.type==\'edit\'\"></i></div><div class=\"vertical-timeline-content\"><p>{{ele.data.type}} <span ng-if=\"ele.data.target\">of <b>{{ele.data.targetMail}}</b></span><div ng-if=\"ele.data.type==\'edit\'\"><div ng-repeat=\"change in ele.data.changes\"><div ng-if=\"change.type==\'change\'\">{{change.path}}: {{change.valueOld}}-><b>{{change.valueNew}}</b></div><div ng-if=\"change.type!=\'change\'\">{{change.path}}: {{change.type}} <b>{{change.value}}</b></div></div></div><div ng-if=\"ele.data.type==\'invite\'\"><div>role: <b>{{ele.data.role}}</b></div><div>firstName: <b>{{ele.data.firstname}}</b></div><div>lastName: <b>{{ele.data.lastname}}</b></div></div></p><span class=\"vertical-date small text-muted\">{{ele.data.time|timeAgo}}</span></div></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/wordFilter/wordFilter.html","<div class=\"wrapper wrapper-content animated fadeInRight\" ng-controller=\"WordFilterController as wordFilterCtrl\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h2>Word Filters</h2></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-2\"><h4>Select Language</h4></div><div class=\"col-sm-4\"><div class=\"input-group\"><select class=\"form-control\" ng-options=\"item.code as item.title for item in wordFilterCtrl.languageListOptions\" ng-model=\"wordFilterCtrl.selectedLanguage\"></select></div></div></div><div ng-if=\"!wordFilterCtrl.loading\"><div ng-if=\"!wordFilterCtrl.selectedLanguage\"><h3>No language selected</h3></div><div ng-if=\"wordFilterCtrl.selectedLanguage\"><textarea name=\"paste\" rows=\"40\" cols=\"20\" ng-model=\"wordFilterCtrl.words\"></textarea></div><div><i>Note: only the first 500 lines will be used</i></div><button class=\"btn btn-success\" ng-if=\"wordFilterCtrl.storedWords!=wordFilterCtrl.words\" ng-click=\"wordFilterCtrl.save();\" type=\"button\"><i class=\"fa fa-pencil\"></i> <span class=\"bold\">Save changes</span></button></div><div ng-if=\"wordFilterCtrl.loading\"><h3>loading...</h3></div></div></div></div></div></div>");
$templateCache.put("app/discipline/YesNoModal/yesNoModal.html","<div class=\"ibox\"><div class=\"ibox-title\"><h2>{{ctrl.title}}</h2></div><div class=\"ibox-content\"><h3>{{ctrl.question}}</h3></div><div class=\"ibox-content\"><button class=\"btn btn-sm m-t-n-xs\" type=\"submit\" ng-click=\"ctrl.yes()\"><strong>Yes</strong></button> <button class=\"btn btn-sm m-t-n-xs\" type=\"submit\" ng-click=\"ctrl.close()\"><strong>No</strong></button></div></div>");
$templateCache.put("app/discipline/banModal/banModal.html","<div class=\"ibox\"><div class=\"ibox-title\"><h2>User</h2><achat-user-display clickable=\"false\" mode=\"full\" name=\"{{ctrl.name}}\" userid=\"{{ctrl.userId}}\" globalid=\"{{ctrl.globalId}}\"></achat-user-display></div><div class=\"ibox-content\"><h3>Ban with reason:</h3><input ng-model=\"ctrl.banReason\" placeholder=\"ban reason\" type=\"text\" class=\"input form-control\"><h4>Discipline Action</h4><button class=\"btn btn-sm btn-primary\" type=\"submit\" ng-enabled=\"ctrl.banReason.length>1\" ng-click=\"ctrl.ban(10,ctrl.banReason)\"><strong>10 Minute Ban</strong></button> <button class=\"btn btn-sm btn-primary\" type=\"submit\" ng-enabled=\"ctrl.banReason.length>1\" ng-click=\"ctrl.ban(30,ctrl.banReason)\"><strong>30 Minute Ban</strong></button> <button class=\"btn btn-sm btn-primary\" type=\"submit\" ng-enabled=\"ctrl.banReason.length>1\" ng-click=\"ctrl.ban(60,ctrl.banReason)\"><strong>1 Hour Ban</strong></button> <button class=\"btn btn-sm btn-primary\" type=\"submit\" ng-enabled=\"ctrl.banReason.length>1\" ng-click=\"ctrl.ban(60*12,ctrl.banReason)\"><strong>12 Hour Ban</strong></button> <button class=\"btn btn-sm btn-primary\" type=\"submit\" ng-enabled=\"ctrl.banReason.length>1\" ng-click=\"ctrl.ban(60*24,ctrl.banReason)\"><strong>24 Hour Ban</strong></button> <button class=\"btn btn-sm btn-primary\" type=\"submit\" ng-enabled=\"ctrl.banReason.length>1\" ng-click=\"ctrl.ban(60*24*7,ctrl.banReason)\"><strong>1 Week Ban</strong></button> <button class=\"btn btn-sm btn-primary\" type=\"submit\" ng-enabled=\"ctrl.banReason.length>1\" ng-click=\"ctrl.ban(60*24*7*4,ctrl.banReason)\"><strong>1 Month Ban</strong></button> <button class=\"btn btn-sm btn-primary\" type=\"submit\" ng-enabled=\"ctrl.banReason.length>1\" ng-click=\"ctrl.ban(60*24*7*4*12*99,ctrl.banReason)\"><strong>99 Year Ban</strong></button></div><div class=\"ibox-content\"><button class=\"btn btn-sm m-t-n-xs\" type=\"submit\" ng-click=\"close()\"><strong>Cancel</strong></button></div></div>");}]);